{
  "AlertsScreens": {
    "alertsTemplates": "Alerts settings",
    "changeExecutor": "Change assignee",
    "changeStatus": "Change status",
    "errors": {
      "failedLoadAlertDetails": "Failed to load alert details",
      "failedLoadAlertsList": "Failed to load alerts list",
      "fieldNotEmptyAndMin3": "This field must not be empty and contain less than three characters",
      "displayScheduleErrorMsg": "Incorrect Cron expression syntax",
      "invalidInitialSchedule": "Invalid initial Cron schedule syntax",
      "invalidSchedule": "Error in the Cron schedule"
    },
    "excludeFromReport": "Exclude from report",
    "excludeReason": "Reason of exclude",
    "excludedFromReport": "Excluded from report",
    "executionHistory": "Alert execution log",
    "manualStart": "Manual start",
    "returnToReport": "Return to report",
    "runNow": "Run now",
    "scheduledStart": "Scheduled start",
    "showDetailedInfo": "Show details info",
    "extendedInfo": {
      "blockedCashBoxesCount": "Number of blocked cashboxes",
      "cashBoxesCount": "Number of cashboxes",
      "punchedDocuments": "Number of punched receipts",
      "vatSum": "Total tax",
      "vatPercent": "Tax rate",
      "documentSum": "Receipt amount",
      "documentGlobalNumber": "Receipt number",
      "gapSize": "Number of lost receipts (gap)",
      "finalDocumentId": "Final fiscal ID",
      "finalDocumentSum": "Final receipt amount",
      "initialDocumentId": "Initial fiscal ID",
      "initialDocumentSum": "Initial receipt amount",
      "finalDocumentGlobalNumber": "Final receipt number",
      "initialDocumentGlobalNumber": "Initial receipt number",
      "status": "Status",
      "details": "Details",
      "createdAtUtc": "Creation date",
      "cashBoxRegDateAtUtc": "Cashbox registration date",
      "companyName": "Taxpayer name",
      "insertedAtUtc": "Receipt insertion date",
      "cashBoxTaxNumber": "Cashbox registration number",
      "companyTaxNumber": "TIN",
      "sum": "Sum",
      "referencedDocId": "Rollback receipt/Moneyback receipt",
      "certificateEndDateAtUtc": "Certificate expiration date",
      "timeDelta": "Clock deviation (sec)",
      "lastOnlineAtUtc": "Last seen online",
      "lastDocCreatedAtUtc": "Last receipt creation date",
      "lastDocInsertedAtUtc": "Date the last receipt was received",
      "invalidGpsCashBox": "Incorrect/absent GPS coordinates of a cashbox",
      "invalidGpsCashBoxCreatedAtUtc": "Date of initial determination of incorrect/absent GPS coordinates",
      "invalidGpsStore": "Incorrect/absent GPS coordinates of an object",
      "storeTotal": "Number of objects",
      "daysBetweenLastDocumentCreated": "Elapsed time since last receipt (number of days)",
      "cashBoxOfflineDate": "Date the cashbox switched offline",
      "daysBetweenOffline": "Offline period (days)",
      "cashBoxStatus": "Cashbox status"
    },
    "rules": {
      "title": "Alert rules settings",
      "addRule": "Add rule",
      "id": "ID",
      "ruleType": "Rule type",
      "taxNumber": "Unique identifier",
      "ruleEntityType": "Rule entity type",
      "insertedAtUtc": "Creation date",
      "searchFieldHint": "Search by unique identifier",
      "editRule": "Edit rule",
      "deleteRuleModalTitle": "Do you really want to delete the rule?",
      "deleteRulesModalTitle": "Do you really want to delete selected rules?",
      "ids": "IDs",
      "errors": {
        "rulesListNotFound": "Rules list not found",
        "addRuleError": "Failed to add rule",
        "editRuleError": "Failed to edit rule",
        "deleteRulesError": "Failed to delete rules",
        "failedDownloadRulesList": "Failed to load list of rules",
        "failedLoadTaxNumbersList": "Failed to load unique identifiers list",
        "failedDownloadRuleTemplate": "Failed to load the template"
      },
      "loadRulesViaExcel": "Load rules from excel",
      "getRulesTemplate": "Download file template",
      "invalidFile": "File does not match to the template",
      "deleteAllRules": "Delete old rules before loading new ones",
      "dropZoneFileText": "Drag and drop an excel file here or click to choose"
    },
    "editSchedule": "Edit alert schedule"
  },
  "AuthScreen": {
    "backToLoginForm": "Back to login form",
    "errors": {
      "loginError": "Login error: {{errorText}}",
      "invalidPhoneNumber": "Invalid phone number",
      "noAccessibleSections": "No sections are available for your account",
      "operatorsNotFound": "Operators not found",
      "requiredField": "Please fill out this field",
      "requiredFieldsNotFilled": "Required fields are not filled",
      "wrongEmailOrPassword": "Wrong login or password",
      "rejectedByRecaptcha": "Access denied. Your activity is regarded as suspicious by reCAPTCHA service, please try to log in later. (SUSPICIOUS status will be removed in {{leftTime}} min)"
    },
    "login": "Login",
    "logout": "Logout",
    "sendCode": "Send",
    "rememberMe": "Remember me",
    "serviceProvider": "Service provider",
    "waitingForCustomerConfirmation": "Please accept the request sent to your mobile phone. Please compare the verification code shown on the screen with the request code."
  },
  "DashboardScreens": {
    "cashboxesByOperators": "Cashboxes by operators",
    "coverage": "Coverage",
    "documentsCounter": "Receipts counter",
    "documentsCounts": {
      "avg": "Avg",
      "max": "Max",
      "min": "Min"
    },
    "errors": {
      "failedLoadDocsCountsStat": "Failed to load statistics on receipt counters",
      "failedLoadDocsStat": "Failed to load receipts statistics",
      "failedToLoadCashboxStat": "Failed to load cashbox statistics",
      "failedToLoadDevicesCountsStat": "Failed to load tokens counts statistics",
      "failedToLoadOperatorCashBoxesStat": "Failed to load operator cashboxes statistics",
      "failedToLoadPaymentTypesStat": "Failed to load payment types statistics",
      "failedToLoadRegistryItemsStat": "Filed to load registry items statistics",
      "failedToLoadTurnoversByActivity": "Failed to load turnovers by activity"
    },
    "top": "Top {{limit}}"
  },
  "MainScreen": {
    "downloadInPDF": "Download as PDF",
    "downloadAsJPG": "Download receipt",
    "errors": {
      "documentDuplicate": "Please, enter cashbox registration number for \"{{documentId}}\"",
      "documentForCashboxNotFound": "Receipt \"{{documentId}}\" for cashbox \"{{taxNumber}}\" is not found.",
      "documentNotFound": "Receipt is not found.",
      "documentNotFoundText": "If the online receipt is not found within 7 days from the date of its creation, create a request in electronic form at the State Tax Service and attach the respective receipt.",
      "invalidDocumentId": "Incorrect receipt identifier",
      "serverError": "Receipt is not found due to server error",
      "forbidden": "Access is denied"
    },
    "linkToParentReceipt": "Link to the related receipt",
    "linksToParentsReceipts": "Links to the related receipts",
    "searchDocumentByIdPlaceholder": "Fiscal ID",
    "searchDocumentByTaxNumberPlaceholder": "Cashbox registration number",
    "watermarkTestWarning": "For testing purposes only! This receipt does not confirm a purchase!",
    "watermarkTestHint": "If you get this receipt for your purchase, please contact your local tax office."
  },
  "MapScreen": {
    "clearFilter": "Clear filter",
    "lat": "Latitude",
    "lng": "Longitude",
    "geographiCoordinates": "Geographic coordinates",
    "coordinates": "Coordinates",
    "onlyPortableCashboxesAreShown": "Please note that only portable cashboxes are shown"
  },
  "RegistryScreens": {
    "byCashboxes": "By cashboxes",
    "byObjects": "By objects",
    "byPeriods": "By periods",
    "cashBoxAlertsHistory": "Cashbox alerts history",
    "cashBoxAuditHistory": "Information about cashbox technical audits",
    "cashBoxStateHistory": "History of cashbox mode changes",
    "cashBoxStatusHistory": "History of cashbox status changes",
    "cashBoxReplacementHistory": "Information about temporary cashboxes installation",
    "cashBoxTimeHistory": "History of clock status changes",
    "cashBoxesRangeSelectHint": "Except cashboxes that were deregistered",
    "cashBoxesTotal": "Cashboxes (total)",
    "completeAttestation": "Complete attestation",
    "countOfCashRegisters": "Number of cash registers",
    "countOfCashboxes": "Number of cashboxes",
    "countOfObjects": "Number of objects",
    "devicesInStock": "Tokens (stock)",
    "documentation": "Documentation",
    "errors": {
      "cashBoxesRequestFailed": "Casboxes request failed",
      "cashBoxesStatsNotFound": "Failed to get cashbox statistics",
      "cashRegisterModelNotFound": "Cash register model \"{{searchText}}\" not found",
      "cashRegistersModelsListReqFailed": "Cash register models list request failed",
      "cashboxNotFound": "Cashbox \"{{searchText}}\" not found",
      "cashboxesListNotFound": "Cashboxes not found!",
      "companiesListNotFound": "Taxpayers not found",
      "companyNotFound": "Taxpayer \"{{searchText}}\" not found",
      "documentsNotFound": "Receipts not found",
      "documentsRequestFailed": "Request for receipts failed",
      "failedLoadFactoryNumbers": "Failed to load a list of cash registers",
      "fieldNotEmpty": "This field must not be empty",
      "operatorDataNotFound": "Operator data not found",
      "operatorNotFound": "Operator \"{{searchText}}\" not found",
      "operatorsListNotFound": "Failed to load operators list",
      "storeWithTaxNumberNotFound": "Object \"{{searchText}}\" not found",
      "storesListNotFound": "Objects not found",
      "storesRequestFailed": "Objects request failed",
      "turnoversRequestFailed": "Request for turnovers info failed",
      "enterIntegerValue": "Enter an integer value from 1 to 100",
      "maxDatesRange": "The maximum date range is 3 years",
      "documentsExtendedDataNotFound": "Extended data for the receipts list not found",
      "devicesListNotFound": "Failed to load tokens list",
      "deviceNotFound": "Token \"{{searchText}}\" not found",
      "cahboxNotRegistered": "Cashbox is not registered",
      "emptyLatitude": "Latitude can not be an empty string",
      "emptyLongitude": "Longitude can not be an empty string",
      "updateStoreInfoFailed": "Failed to update object info",
      "latitudeOutOfBounds": "Enter a latitude value from {{min}} to {{max}}",
      "longitudeOutOfBounds": "Enter a longitude value from {{min}} to {{max}}",
      "fileToBig": "File too big",
      "fileToSmall": "File too small",
      "storeOutOfAzBounds": "The object is in the wrong region",
      "allowableLongitudeRange": "Allowable longitude range: {{min}} - {{max}}",
      "allowableLatitudeRange": "Allowable latitude range: {{min}} - {{max}}",
      "updateInOffline": "Update is possible only in the Online mode",
      "firmwareUpdateNoSuitableVersions": "There is no list of suitable versions for updating",
      "waitingForSuitableVersionsList": "Waiting for a suitable versions list...",
      "getSuitableTargetVersionsFailed": "Failed to load a list of suitable for firmware update versions",
      "firmwareUpdateNotNeeded": "The current version is up to date. No need to update",
      "firmwareUpdateForOldVersion": "The update is possible only for firmware versions starting from {{version}}",
      "cashboxOutOfAzBounds": "The cashbox is in the wrong region",
      "cashboxLocationDataNotFound": "Cashbox location data not found",
      "versionError": "A version name must be from 1 to {{maxLength}} characters. Please use only numbers and the following character set: v . -",
      "emptyAttestationResult": "Please select some attestation result",
      "cashRegisterModelVersionsNotFound": "Request to get software versions for the cash register model failed",
      "cashRegisterModelVersionCheckSumsNotFound": "Request to get check sums list for the software version {{versionName}} failed",
      "cashRegisterModelDocumentsNotFound": "Request to get documents list for the cash register model failed",
      "waitingForSoftwareVersions": "Waiting for a software versions list...",
      "emptySoftwareVersionsList": "The list of software versions for this model is empty",
      "cashRegisterCategoryNotSet": "Before to manage the attestation process, please set a cash register category",
      "updateModelFailed": "Failed to update cash register model info",
      "getStorePhotosFailed": "Failed to get a list of object photos",
      "getCashboxLocationsHistoryFailed": "Failed to get the cashbox locations history data",
      "getCashboxTrackingDataFailed": "Failed to get the cashbox tracking data",
      "failedToGetDocument": "Failed to get receipt data",
      "requestToUpdateDeviceCertificateFailed": "Request to update token certificate failed",
      "certUpdateAlreadyInProgress": "Request failed. The previous task to update token certificate is in progress",
      "requestToCreateCashBoxLogsFailed": "Request to fetch cashbox logs failed",
      "cashBoxLogsRequestAlreadyInProgress": "Request failed. The previous task to fetch cashbox logs is in progress",
      "firmwareUpdateAlreadyInProgress": "Request failed. The previous task to update token firmware is in progress",
      "requestToUpdateDeviceFirmwareFailed": "Request to update token firmware failed",
      "envInfoRequestAlreadyInProgress": "Request failed. The previous task to fetch environment info is in progress",
      "requestToGetEnvInfoFailed": "Request to fetch environment info failed",
      "requestInOffline": "The request is possible only in the Online mode",
      "blockCashBoxFailed": "Request to block the cashbox failed",
      "unblockCashBoxFailed": "Request to unblock the cashbox failed",
      "removeBlockUnblockScheduleFailed": "Failed to delete the schedule",
      "singleDateValidationHint": "The selected time must be greater than the current time",
      "datesPeriodValidationHint": "The upper limit of the period must be greater than the lower one",
      "changeCashBoxStatusFailed": "Request to change cashbox status failed",
      "fiscalDriverOperationForOldVersion": "The operation is possible only for fiscal driver versions starting from {{version}}",
      "taxpayerDataNotFound": "Taxpayer data not found",
      "cashRegistersListReqFailed": "Cash register list request failed",
      "cashRegisterNotFound": "Cash register \"{{searchText}}\" not found",
      "createInitOtpFailed": "One-time password creation failed"
    },
    "logsList": "Cashbox logs",
    "modelStatusHistory": "History of model status changes",
    "receiptAmountRangeSelectHint": "Except open shift and z-report receipts",
    "requestLogs": "Request logs",
    "startAttestation": "Start attestation",
    "storesRangeSelectHint": "Active objects only",
    "turnoverForEntirePeriod": "Turnover for the entire period",
    "timeRange": "Time range",
    "timeRangeTypes": {
      "QUICK_SELECT": "QUICK SELECT",
      "SHOW_DATES": "DATE RANGE",
      "COMMONLY_USED": "COMMONLY USED"
    },
    "hideFiltersPanel": "Hide filters panel",
    "confirmIgnoreFilters": "Filters were changed but not applied. They will be reset to their previous state.",
    "donorHint": "Broken cashbox, for which the current cashbox was registered to replace",
    "replacementsHint": "Cashboxes registered to replace the current cashbox",
    "deviceStatusHistory": "History of token status changes",
    "deviceFirmwareHistory": "History of token firmware versions",
    "deviceRegisteredCashbox": "Information about currently registered cashbox",
    "deviceOperatorHistory": "History of token transfers between operators",
    "deviceRegistrationHistory": "History of token registrations within cashboxes",
    "coordinatesHistory": "History of coordinates changes",
    "cashBoxesList": "Cashboxes list",
    "cashBoxStatistics": "Cashboxes statistics",
    "latitudeLongitude": "Latitude / Longitude",
    "doubleClickToSetCoordinates": "Double click to set coordinates on the map",
    "modalMapDialogTitle": "Please point the object location by double clicking on the map",
    "initialCoordinates": "Initial coordinates",
    "selectedCoordinates": "Selected coordinates",
    "deviceFirmwareUpdatesHistory": "History of token firmware updates",
    "selectSuitableTargetVersion": "Select a target firmware version from the list of suitable ones",
    "currentCashboxLocation": "Current cashbox location",
    "currentStoreLocation": "Object location",
    "selectedHistoryLocation": "Selected history cashbox location",
    "viewControl": "View control",
    "historyLocation": "History location",
    "countOfCashboxesByMode": "Number of cashboxes by mode",
    "countOfCashboxesByStatus": "Number of cashboxes by status",
    "countOfCashboxesByType": "Number of cashboxes by type",
    "countOfObjectsByStatus": "Number of objects by status",
    "startReattestation": "Start reattestation",
    "completeReattestation": "Complete reattestation",
    "eliminateCashRegisterModel": "Eliminate the model",
    "activateCashRegisterModel": "Activate the model",
    "attestationCompleted": "Attestation completed",
    "attestationNotCompleted": "Attestation is not completed. {{reason}}",
    "softwareVersionsHistory": "Model software versions",
    "markVersionAsOutdated": "Mark the version as outdated",
    "activateVersion": "Activate the version",
    "copyCheckSum": "Copy the version check sum",
    "confirmActivateCashRegisterModel": "Do you really want to activate the cash register model?",
    "confirmEliminateCashRegisterModel": "Do you really want to eliminate the cash register model?",
    "confirmMarkVersionOutdated": "Do you really want to mark the software version as outdated?",
    "confirmActivateVersion": "Do you really want to activate the software version?",
    "markOutdated": "Mark outdated",
    "selectSoftwareVersionForDocuments": "Select software version if the documents are associated with one of them",
    "checkSumHistory": "History of check sum changes",
    "noDataForCheckSumHistory": "There is no history of check sum changes",
    "noDataForLocationsHistory": "There is no data to display the history of coordinates changes",
    "noDataForTrackingHistory": "There is no data to display the cashbox tracking",
    "viewPictureDocument": "View receipt image",
    "documentImage": "Receipt image",
    "documentDetails": "Receipt details",
    "relatedDocuments": "Related receipts",
    "documentIdentification": "Receipt identification",
    "incorrectDocumentDateHint": "Incorrect receipt generation date",
    "technicalTasks": "Service and technical features",
    "deviceCertUpdatesHistory": "History of token certificate updates",
    "certificateUpdate": "Token certificate update",
    "requestsHistory": "Requests history",
    "updateCertificate": "Update certificate",
    "refreshHistory": "Refresh history",
    "certUpdateRequestCreated": "Request to update the token certificate created",
    "logsRequestCreated": "Request to get cashbox logs created",
    "cashBoxLogsHistory": "Cashbox logs requests history",
    "firmwareUpdateRequestCreated": "Request to update the token firmware created",
    "updateFirmware": "Update firmware",
    "firmwareUpdate": "Token firmware update",
    "envInfoRequestCreated": "Request to get environment info created",
    "envInfoHistory": "Environment info requests history",
    "requestEnvInfo": "Request info",
    "envInfoList": "Environment info",
    "modelsListLimitationByOperatorHint": "Options for this filter are limited if operator names are selected",
    "softwareVersionsLimitationByModelsHint": "Options for this filter depend on the selected cash register model",
    "cashRegisterModelStatistics": "Cash register models statistics",
    "generalStatistics": "General statistics",
    "cashRegisterStatusHistory": "History of cash register status changes"
  },
  "ReportsScreen": {
    "errors": {
      "failedLoadReportsList": "Failed to load reports list"
    },
    "reportPeriod": "Report period",
    "reportDate": "Report date",
    "searchFilterItems": {
      "cashBoxTaxNumbers": "Cashbox registration number",
      "companyTaxNumbers": "TIN",
      "operatorTaxNumbers": "Operator TIN",
      "storeTaxNumbers": "Object code"
    },
    "turnovers": {
      "correctionsCount": "Correction: number",
      "correctionsSum": "Correction: sum",
      "moneybacksCount": "Moneyback: number",
      "moneybacksSum": "Moneyback: sum",
      "rollbacksCount": "Rollback: number",
      "rollbacksSum": "Rollback: sum",
      "salesCount": "Sale: number",
      "salesSum": "Sale: sum"
    },
    "timeIsIgnored": "Time in this filter is ignored in the report by day",
    "byDay": "Report with aggregation by day",
    "byDayHint": "The report will be downloaded with aggregation by day"
  },
  "StatisticsScreen": {
    "goToCashboxesList": "Go to the cashboxes list"
  },
  "SystemScreens": {
    "addUser": "Add user",
    "adminPanel": "Admin panel",
    "backToMonitoring": "Back to monitoring",
    "basicInfo": "Basic info",
    "changePassword": "Change password",
    "confirmBlockUser": "Do you really want to block the user?",
    "confirmDeleteUser": "Do you really want to delete the user?",
    "confirmUnblockUser": "Do you really want to unblock the user?",
    "contactInfo": "Contact info",
    "copyPassword": "Copy password",
    "currentPasswordNotShown": "The current user password is not displayed",
    "editEmail": "Edit email",
    "editFirstName": "Edit  first name",
    "editLastName": "Edit last name",
    "editMiddleName": "Edit middle name",
    "editPhone": "Edit phone number",
    "editUser": "Edit user data",
    "errors": {
      "addUserFailed": "Failed to add user",
      "blockUserFailed": "Failed to block user \"{{searchText}}\"",
      "changePasswordFailed": "Failed to change user password",
      "deleteUserFailed": "Failed to delete user \"{{searchText}}\"",
      "emptyAccessRights": "Select user access rights",
      "emptyFirstName": "First name can not be an empty string",
      "emptyLastName": "Last name can not be en empty string",
      "emptyPassword": "Password can not be an empty string",
      "incorrectUserRoles": "Additional roles do not match the user's primary role",
      "invalidEmail": "Please enter valid email",
      "invalidStoredPhone": "The previously saved number {{phone}} is invalid. Enter a new number",
      "invalidStoredPhoneContactAdministrator": "The saved phone number is invalid. Contact your administrator to change it",
      "invalidPassword": "Invalid password",
      "phoneDoesNotMatchCountry": "The previously saved number {{phone}} does not match the selected country. Enter a new number",
      "phoneRequired": "Phone number is required",
      "passwordsNotSame": "Passwords are not the same",
      "unblockUserFailed": "Failed to unblock user \"{{searchText}}\"",
      "updateUserInfoFailed": "Failed to update user information",
      "userInfoNotFound": "User info not found \"{{searchText}}\"",
      "usersNotFound": "Users not found",
      "passwordTooShort": "Password must be at least {{minLength}} characters",
      "emptyTaxAuthority": "Tax authority can not be an empty string",
      "passwordTooLong": "Maximum password length is {{maxLength}} characters",
      "passwordNotStrong": "The password is not strong enough. Please use at least one upper case letter, one lower case letter, one digit and one special character",
      "passwordMinMaxLimits": "Password length is from {{minLength}} to {{maxLength}} characters"
    },
    "generatePassword": "Generate password",
    "logoutOnChangePassword": "Changing your password will log you out",
    "newPassword": "New password",
    "oldPassword": "Old password",
    "otherInfo": "Other info",
    "retypeNewPassword": "Retype new password",
    "retypePassword": "Retype password",
    "removeStoredPhone": "Remove previously saved number",
    "selectTaxAuthority": "Select tax authority",
    "taxOfficer": "Tax officer",
    "userAdded": "User added",
    "userManagement": "User management",
    "ifOldPasswordIsForgotten": "If you have forgotten the password, please contact your administrator",
    "userProfile": "User profile"
  },
  "alert": {
    "alertCreationDate": "Alert creation date",
    "alertExecutionStatuses": {
      "FAILED": "Failed",
      "RUNNING": "In progress",
      "SCHEDULED": "Scheduled",
      "SUCCEED": "Successful"
    },
    "alertStatuses": {
      "ALL": "All",
      "CLOSED": "Closed",
      "IN_PROGRESS": "In progress",
      "OPEN": "Open",
      "RESOLVED": "Processed"
    },
    "alertType": "Alert type",
    "alertTypes": {
      "CASH_BOX_CERTIFICATE_IS_EXPIRED_ALERT": "Cashbox certificate is expired",
      "CASH_BOX_WITHOUT_AUDIT_ALERT": "Cashboxes without technical audit",
      "CASH_BOX_WITH_FAILED_AUDIT_ALERT": "The cashbox last technical audit was unsuccessful",
      "CASH_BOX_WITH_INVALID_TIME_ALERT": "Cashbox with invalid clock",
      "CREATION_DATE_IS_AFTER_THAN_INSERTION_DATE_ALERT": "Creation date is later than insertion date",
      "INVALID_DOCUMENT_REFERENCE_ALERT": "Invalid receipt reference",
      "DOCUMENTS_CHAIN_GAP_ALERT": "Breaking the cryptographic chain of receipts",
      "WRONG_VAT_PERCENT_ALERT": "Cash transaction at a non-existent tax rate",
      "INACTIVE_STORE_WITH_ACTIVE_CASH_BOX_ALERT": "Inactive object with active cashbox",
      "ACTIVE_STORE_WHERE_ALL_CASH_BOXES_BLOCKED_ALERT": "All cashboxes of the active object are blocked",
      "ACTIVE_TAXPAYER_WITH_NO_ACTIVE_CASH_BOX_ALERT": "All cashboxes of active taxpayer are blocked",
      "CLOSED_TAXPAYER_WITH_ACTIVE_CASH_BOX_ALERT": "Taxpayer in the Closed status has active cashboxes",
      "ACTIVE_CASH_BOX_WITHOUT_DOCS_ALERT": "Active cashbox has not been operating for 45 days",
      "CASHBOX_WITH_INVALID_GPS_ALERT": "Cashbox with incorrect or absent GPS coordinates",
      "STORE_WITH_INVALID_GPS_ALERT": "Object with incorrect or absent GPS coordinates"
    },
    "assignee": "Assignee",
    "priorities": {
      "MAJOR": "High",
      "MINOR": "Low",
      "NORMAL": "Medium"
    },
    "prioritiesFull": {
      "MAJOR": "High priority",
      "MINOR": "Low priority",
      "NORMAL": "Medium priority"
    },
    "priority": "Priority",
    "schedule": "Schedule",
    "alertRunDescription": "Data collected during the specified interval will be used to check this alert",
    "runAlertTitle": "Start checking"
  },
  "app": {
    "address": "Address",
    "all": "All",
    "cancel": "Cancel",
    "collapseAll": "Collapse",
    "comment": "Comment",
    "copied": "Copied",
    "copy": "Copy",
    "data": "Data",
    "date": "Date",
    "dateFrom": "From date",
    "dateTo": "To date",
    "dateTime": "Date / Time",
    "delete": "Delete",
    "download": "Download",
    "duration": "Duration",
    "edit": "Edit",
    "file": "File",
    "filter": "Filter",
    "filters": "Filters",
    "from": "From",
    "hide": "Hide",
    "id": "ID",
    "link": "Link",
    "loading": "Loading...",
    "mode": "Mode",
    "name": "Name",
    "note": "Note",
    "of": "of",
    "other": "Other",
    "periods": {
      "currentMoment": "Current moment",
      "currentMonth": "Current month",
      "currentYear": "Current year",
      "forLast30Days": "For the last 30 days",
      "today": "Today",
      "yesterday": "Yesterday"
    },
    "periodsConsts": {
      "PREVIOUS_DAY": "Previous day",
      "PREVIOUS_MONTH": "Previous month",
      "PREVIOUS_WEEK": "Previous week"
    },
    "quantity": "Quantity",
    "save": "Save",
    "settings": "Settings",
    "showCardView": "Show card view",
    "showTableView": "Show table view",
    "status": "Status",
    "sum": "Sum",
    "time": "Time",
    "timePeriodsShort": {
      "day": "d",
      "hour": "h",
      "minute": "min",
      "month": "mo",
      "second": "sec",
      "year": "yr"
    },
    "to": "To",
    "total": "Total",
    "type": "Type",
    "unhide": "Expand",
    "periodsCommonlyUsed": {
      "today": "Today",
      "yesterday": "Yesterday",
      "thisWeek": "This week",
      "thisMonth": "This month",
      "thisYear": "This year",
      "weekToDate": "Week to date",
      "monthToDate": "Month to date ",
      "yearToDate": "Year to date"
    },
    "last": "Last",
    "timeUnits": {
      "minutes": "minutes",
      "hours": "hours",
      "days": "days",
      "weeks": "weeks",
      "years": "years",
      "months": "months"
    },
    "ok": "OK",
    "doNotExist": "Do not exist",
    "statuses": "Statuses",
    "noData": "No data",
    "preview": "Preview",
    "yes": "Yes",
    "no": "No",
    "show": "Show",
    "shown": "Shown",
    "fileName": "File name",
    "management": "Management",
    "close": "Close",
    "hints": {
      "partialSearchByOneUnable": "Search by part of value is not possible. Please enter full value.",
      "partialSearchByOne": "Search by part of value is possible if only one element is entered.",
      "searchByList": "To search by a list please specify full values separated by commas.",
      "searchByListUnable": "Search by a list of values is not possible. Please enter one value or its part.",
      "searchFieldLengthMoreThan": "The length of the search string cannot be more than {{number}}.",
      "enterValueHint": "The value must be {{number}} characters",
      "fieldCanNotBeEmpty": "The field can not be empty",
      "multipleValuesShallBeNumeric": "The value can contain only numbers. You can enter multiple values ​​separated by commas.",
      "enterNumericValueHint": "The value must be {{number}} numbers"
    },
    "filesDeleted": "File(s) deleted",
    "confirmDeleteFile": "Do you really want to delete the file?",
    "confirmDeleteFiles": "Do you really want to delete the selected files?",
    "numberOfSelectedFiles": "Number of selected files: {{number}}",
    "category": "Category",
    "currentValue": "Current value",
    "targetValue": "New value",
    "selectTargetValue": "Please select new value",
    "enterTargetValue": "Please enter new value",
    "selectInterval": "Please select date interval",
    "selectedFilters": "Selected filters",
    "apply": "Apply",
    "enterValue": "Enter a value",
    "reloadData": "Reload data",
    "fromForRange": "From",
    "toForRange": "To",
    "selected": "Selected",
    "add": "Add",
    "downloadZipFile": "Download zip file",
    "obsolete": "Obsolete",
    "search": "Search",
    "clear": "Clear",
    "scrollToTop": "Scroll to top",
    "scrollToBottom": "Scroll to bottom",
    "increaseRowHeight": "Increase row height",
    "decreaseRowHeight": "Decrease row height"
  },
  "cashBox": {
    "audit": "Audit",
    "auditStatuses": {
      "failed": "Not passed",
      "passed": "Passed",
      "wasNotPerformed": "Audit was not performed"
    },
    "blockAtTime": "From a given time",
    "blockScheduledOn": "Blocking is scheduled for",
    "cashboxRegistrationDate": "Cashbox registration date",
    "cashboxState": "Cashbox mode",
    "cashboxStates": {
      "OFFLINE": "Offline",
      "ONLINE": "Online"
    },
    "cashboxStatus": "Cashbox status",
    "cashboxStatuses": {
      "ACTIVE": "Active",
      "BLOCKED": "Blocked",
      "BROKEN": "Broken",
      "ELIMINATED": "Eliminated",
      "REGISTRATION": "Registration",
      "RESET": "Reset",
      "SERVICE": "Service"
    },
    "cashboxTaxNumber": "Cashbox registration number",
    "cashboxType": "Cashbox type",
    "cashboxTypes": {
      "PHYSICAL": "Physical",
      "SOFTWARE": "Software",
      "VIRTUAL": "Virtual",
      "ECOMM": "E-commerce"
    },
    "certificateExpireDate": "Certificate expiration date",
    "cleanSchedule": "Clear schedule",
    "clock": "Clock",
    "clockStatus": "Clock status",
    "clockStatuses": {
      "correct": "Correct",
      "deviated": "Deviated"
    },
    "commentForCurrentStatus": "Comment on the cashbox status",
    "commentOnBlocking": "Comment on blocking",
    "dateFromTo": "Set period",
    "daysOffline": "Offline period (days)",
    "expiredCertificate": "Expired certificate",
    "invalidTime": "Invalid clock",
    "lastAuditDate": "Latest technical audit date",
    "lastDocDaysAgo": "Inactivity period (days)",
    "registeredThisYear": "Registered this year",
    "pluralProps": {
      "active": "Active",
      "blocked": "Blocked",
      "inactive": "Inactive",
      "notBlocked": "Not blocked",
      "primary": "Primary",
      "temporary": "Temporary"
    },
    "replacement": "Replacement",
    "replacementTypes": {
      "primary": "Primary",
      "temporary": "Temporary"
    },
    "timeDeviation": "Clock deviation",
    "unblockAtTime": "From selected time",
    "unblockComment": "Comment on unblocking",
    "unblockingScheduled": "Unblocking is scheduled for",
    "validTime": "Valid clock",
    "cashboxHierarchy": "Cashbox hierarchy",
    "cashboxHierarchyNotions": {
      "currentCashbox": "Current cashbox",
      "childCashboxes": "Replacement cashboxes",
      "parentCashboxes": "Donor cashboxes",
      "parent": "Donor",
      "children": "Replacements",
      "child": "Replacement",
      "parentCashbox": "Donor-cashbox"
    },
    "certificateExpireDateFilter": "Certificate expiration date",
    "dateLastCoordinatesUpdate": "Date of the last coordinates update",
    "gpsTracking": "GPS tracking",
    "tracking": "Tracking",
    "trackingAccuracy": "Accuracy",
    "cashboxTaskStatuses": {
      "COMPLETED": "Success",
      "FAILED": "Failed",
      "REJECTED": "Rejected",
      "CREATED": "Processing ..."
    },
    "blockCashbox": "Block the cashbox",
    "unblockCashbox": "Unblock the cashbox",
    "changeCashboxStatus": "Change cashbox status",
    "certificateStatus": {
      "expired": "Expired",
      "valid": "Valid"
    }
  },
  "cashRegister": {
    "applicationArea": "Application area",
    "attestationKey": "Attestation key",
    "cashRegisterFactoryNumber": "Cash register factory number",
    "agent": "Agent cash register",
    "dateTypeByModelStatuses": {
      "ACTIVE": "Registry entering date",
      "ATTESTATION": "Attestation start date",
      "ELIMINATED": "Date of elimination from registry",
      "REGISTRATION": "Registration request date",
      "REATTESTATION": "Last reattestation date"
    },
    "hardwareName": "Hardware name",
    "modelName": "Model name",
    "modelStatus": "Cash register model status",
    "modelStatuses": {
      "ACTIVE": "Active",
      "ATTESTATION": "Attestation",
      "ELIMINATED": "Eliminated",
      "REGISTRATION": "Registration",
      "REATTESTATION": "Reattestation"
    },
    "pluralProps": {
      "active": "Active",
      "eliminated": "Eliminated"
    },
    "softwareName": "Software name",
    "usage": "Usage",
    "usageItems": {
      "notUsed": "Not used",
      "used": "Used"
    },
    "attestationResult": "Attestation result",
    "attestationResults": {
      "ACCEPT": "Accept",
      "REJECT": "Reject"
    },
    "attestationErrors": {
      "sevenDaysWarning": "Attestation process takes at least 7 days",
      "SEVEN_DAYS": "The seven-day period for attestation has not yet expired",
      "WRONG_VERSION_NAME": "The selected version number is already in use",
      "CHECKSUM_CHANGED": "The check sum has been modified in the last seven days",
      "FD_VERSION_CHANGED": "The fiscal driver version has been modified in the last seven days",
      "FD_VERSION_OUTDATED": "Fiscal driver version is outdated",
      "FW_VERSION_OUTDATED": "Firmware version is outdated"
    },
    "softwareVersionStatus": "Software version status",
    "softwareVersion": "Software version",
    "softwareVersions": "Software versions",
    "versionStatuses": {
      "ACTIVE": "Active",
      "ATTESTATION": "Attestation",
      "OUTDATED": "Outdated",
      "ELIMINATED": "Eliminated",
      "UNKNOWN": "Unknown"
    },
    "reenterSoftwareVersion": "Re-enter software version if you want to change it",
    "os": "Operating system",
    "cashRegisterCategory": "Cash register category",
    "cashRegisterTypes": {
      "agent": "Agent",
      "notAgent": "Not agent",
      "portable": "Portable",
      "stationary": "Stationary"
    },
    "cashRegisterModelTaxNumber": "Cash register model registration number",
    "statuses": {
      "STOCK": "In stock",
      "READY": "Ready",
      "STORE": "On object",
      "ELIMINATED": "Liquidated"
    },
    "registeredWithCashBox": "Registered with cashbox",
    "cashRegisterModelsShort": "Cash register models",
    "cashRegisterModelName": "Cash register model name",
    "otpCode": "One-time password",
    "generateOtpCode": "Generate one-time password",
    "otpWarning": "Copy the one-time password and store it in a safe place. After closing this window, you will not be able to recover the password.",
    "expiredAt": "The one-time password is valid until: {{date}}",
    "modelTaxNumber": "Model registration number"
  },
  "company": {
    "activity": "Activity",
    "companyName": "Taxpayer name",
    "companyStatus": "Taxpayer status",
    "companyStatuses": {
      "ACTIVE": "Active",
      "CLOSED": "Closed",
      "SUSPENDED": "Suspended"
    },
    "companyTaxNumber": "TIN",
    "taxpayerType": "Legal status",
    "taxpayerTypes": {
      "LEGAL": "Legal entity",
      "PHYSICAL": "Individual"
    }
  },
  "device": {
    "age": "Age",
    "deviceStatus": "Token status",
    "deviceStatuses": {
      "BROKEN": "Broken",
      "PRODUCED": "Produced",
      "READY": "Ready",
      "RECYCLED": "Recycled",
      "SERVICE": "Service",
      "STOCK": "In stock",
      "STORE": "On object",
      "FIXED": "Fixed",
      "LOST": "Lost"
    },
    "deviceUSBType": "USB type",
    "deviceUSBTypes": {
      "microB": "Micro",
      "A": "Standard"
    },
    "fiscalDriverVersion": "Fiscal driver version",
    "wearout": "Wearout",
    "workability": "Workability level",
    "workabilityLevels": {
      "INVALID": "Invalid",
      "JUNIOR": "Junior",
      "NEW": "New",
      "SENIOR": "Senior",
      "VETERAN": "Mature"
    },
    "experience": "Operation period",
    "firmware": "Firmware",
    "commentForCurrentStatus": "Comment on the token status",
    "firmwarePlural": "Firmware",
    "deviceStatusGroups": {
      "taxOfficeStock": "Tax office stock",
      "operatorStock": "Operator stock",
      "onObject": "On object",
      "inService": "In service",
      "outOfUse": "Out of use"
    },
    "targetVersion": "Target version",
    "resultVersion": "Installed version",
    "currentVersion": "Current version",
    "firmwareVersion": "Firmware version",
    "deviceFactoryNumber": "Token factory number",
    "procCount": "Number of processors",
    "utcOffsetSec": "Offset of local time to UTC (sec)",
    "ramSizeMB": "RAM size (Mb)",
    "productionID": "Production ID",
    "productionPlace": "Production place",
    "productionDate": "Production start date",
    "hardwareVersion": "Hardware version",
    "production": "Production",
    "fiscalDriver": "Fiscal driver",
    "dump": "Dump",
    "repair": "Repair"
  },
  "document": {
    "KTM": "Trade markup",
    "carNumber": "Vehicle registration plates",
    "cashier": "Cashier",
    "creditpayContractNumber": "Creditpay contract number",
    "contractNumber": "Contract number",
    "creditPayerInfo": "Credit payer information",
    "documentCreatedDate": "Receipt date",
    "documentInsertedDate": "Receipt insertion date",
    "documentType": "Receipt type",
    "firstOperation": "First operation date",
    "fiscalId": "Fiscal ID",
    "shortFiscalId": "Fiscal ID (short)",
    "lastDocument": "Latest receipt",
    "lastDocumentDate": "Date of the latest receipt",
    "lastOperation": "Last operation date",
    "notTaxable": "VAT-exempt",
    "paidInCash": "Paid cash",
    "parentFiscalIdLabels": {
      "correctionFiscalId": "Fiscal ID of correction receipt",
      "creditpayFiscalId": "Fiscal ID of creditpay receipt",
      "moneybackFiscalId": "Fiscal ID of moneyback receipt",
      "prepayFiscalId": "Fiscal ID of prepayment receipt",
      "prepayFiscalIds": "Fiscal IDs of prepayment receipts",
      "saleFiscalId": "Fiscal ID of sale receipt",
      "unknown": "Fiscal ID of parent receipt"
    },
    "parentFiscalId": "Parent fiscal ID",
    "paymentNumber": "Payment sequence number",
    "paymentType": "Payment type",
    "paymentTypes": "Payment types",
    "paymentTypesList": {
      "bonus": "Bonus",
      "cash": "Cash",
      "cashless": "Cashless",
      "credit": "Credit",
      "prepayment": "Prepayment"
    },
    "positionInShift": "Receipt order in shift",
    "price": "Price",
    "productName": "Product",
    "productItems": "Product items",
    "receiptAmount": "Receipt amount",
    "residue": "Residue payable (debt)",
    "returnOfChange": "Change",
    "sum": "Total",
    "tax": "Tax",
    "taxRate": "Tax rate",
    "taxSum": "Total tax",
    "tel": "Tel",
    "total": "Total",
    "totalTax": "Total tax",
    "type": {
      "Correction": "Correction",
      "CreditPay": "Creditpay",
      "MoneyBack": "Moneyback",
      "OpenShift": "Open shift",
      "Prepayment": "Prepayment",
      "RollBack": "Rollback",
      "Sale": "Sale",
      "ZReport": "Z-report"
    },
    "typeForSelects": {
      "CORRECTION": "Correction",
      "CREDITPAY": "Creditpay",
      "MONEY_BACK": "Moneyback",
      "OPEN_SHIFT": "Open shift",
      "PREPAY": "Prepayment",
      "ROLLBACK": "Rollback",
      "SALE": "Sale",
      "Z_REPORT": "Z-report"
    },
    "typeFullName": {
      "correctionDocument": "Correction receipt",
      "creditpayDocument": "Creditpay receipt",
      "moneybackDocument": "Moneyback receipt",
      "openShiftDocument": "Open shift receipt",
      "prepayDocument": "Prepayment receipt",
      "rollbackDocument": "Rollback receipt",
      "saleDocument": "Sale receipt",
      "saleDocumentCredit": "Sale receipt (creditpay)",
      "saleDocumentWithPrepay": "Sale receipt (prepayment)",
      "zReportDocument": "Close shift receipt (Z-report)"
    },
    "units": {
      "cubicMeters": "m³",
      "kilos": "kg",
      "liters": "liters",
      "meters": "m",
      "squareMeters": "m²",
      "things": "pc"
    },
    "measureUnit": "Units",
    "zReport": {
      "correctionQuantity": "Quantity",
      "correctionTotal": "Total",
      "creditQuantity": "Quantity",
      "creditTotal": "Total",
      "firstPaymentDoc": "First receipt №",
      "lastPaymentDoc": "Last receipt №",
      "moneyBackQuantity": "Quantity",
      "moneyBackTotal": "Total",
      "numberOfDocumentsPerShift": "Number of receipts punched during the shift",
      "numberOfUnsentDocuments": "Number of receipts unsent to the STS",
      "prepaymentQuantity": "Quantity",
      "prepaymentTotal": "Total",
      "rollBackQuantity": "Quantity",
      "rollBackTotal": "Total",
      "salesQuantity": "Quantity",
      "salesTotal": "Total",
      "shiftClosedDate": "Shift closing date",
      "shiftOpenedDate": "Shift opening date",
      "turnoverTax": "Turnover tax"
    },
    "taxRates": {
      "0": "0%",
      "2": "2%",
      "8": "8%",
      "18": "18%",
      "OTHER": "Other"
    },
    "taxRatesExcel": {
      "zero": "0%",
      "two": "2%",
      "eight": "8%",
      "eighteen": "18%",
      "other": "Other"
    },
    "docNumber": "Receipt number",
    "globalDocNumber": "Global receipt number",
    "parentDocDate": "Parent receipt date",
    "parentDocSum": "Parent receipt sum",
    "gasStation": "Gas station information",
    "gasStationInfo": {
      "fdp": "FDP №",
      "pump": "Pump №",
      "gun": "Gun №",
      "reservoir": "Reservoir №"
    },
    "agentInfo": "Agent info",
    "committentInfo": {
      "tin": "Committent TIN",
      "name": "Committent name",
      "agentContract": "Agent contract number",
      "agentCommission": "Agent's commission percentage"
    },
    "itemAgentCommission": "Agent's commission",
    "bonusCardNumber": "Bonus card number",
    "retrievalReferenceNumber": "Interbank transaction number (RRN)",
    "guestsCount": "Number of guests",
    "marginPrice": "Margin price",
    "marginSum": "Margin sum",
    "productCode": "Product code",
    "productCodeType": "Product code type",
    "productCodeTypes": {
      "GTIN": "GTIN",
      "ISBN": "ISBN",
      "ISSN": "ISSN",
      "EAN": "EAN",
      "DUNS": "DUNS"
    },
    "productCodeTypesTooltip": {
      "GTIN": "Global Trade Item Number",
      "ISBN": "International Book Number",
      "ISSN": "International Serial Number",
      "EAN": "European Article Number",
      "DUNS": "Data Universal Numbering System"
    },
    "markingCode": "Marking code",
    "documentVersion": "Version of receipt format",
    "itemHash": "Product names hash",
    "markingCodes": "Marking codes",
    "paymentInfo": "Payment info",
    "operationInfo": "Operation info",
    "openShiftOperationNumber": "Open shift operation number",
    "zReportOperationNumber": "Close shift operation number",
    "currencyReport": "Currency report",
    "numberOfDocuments": "Number of receipts",
    "taxDetails": "Tax details",
    "notTaxableSum": "Amount exempt from VAT",
    "creditPaymentSum": "Credit payment sum",
    "approvalCode": "Approval code",
    "interbankTransactions": "Interbank transactions",
    "restoredDocument": "The receipt was restored from token backup",
    "restoredFromBackup": "Restored from token backup",
    "restored": "Restored",
    "paid": "Paid"
  },
  "domain": {
    "accountMenu": "Account menu",
    "addListItem": "Add list item",
    "alert": "Alert",
    "alerts": "Alerts",
    "block": "Block",
    "cashRegister": "Cash register",
    "cashRegisterModel": "Cash register model",
    "cashRegisterModels": "Cash register models",
    "cashRegisters": "Cash registers",
    "cashbox": "Cashbox",
    "cashboxes": "Cashboxes",
    "companies": "Taxpayers",
    "company": "Taxpayer",
    "currency": "Currency",
    "device": "Token",
    "devices": "Tokens",
    "document": "Receipt",
    "documents": "Receipts",
    "elements": "Elements",
    "factoryNumber": "Factory number",
    "financial": "Financial",
    "home": "Home",
    "info": "Info",
    "infographic": "Infographic",
    "legalAddress": "Legal address",
    "loadingData": "Loading data...",
    "map": "Map",
    "nowInSystem": "Now in the system",
    "operator": "Operator",
    "operators": "Operators",
    "parameters": "Parameters",
    "period": "Period",
    "registrationDate": "Registration date",
    "registrationNumber": "Registration number",
    "registry": "Registry",
    "report": "Report",
    "reports": "Reports",
    "retriesCount": "Retries count",
    "rowsPerPage": "Rows per page",
    "searchBy": "Search by",
    "searchDocument": "Receipt search",
    "security": "Security",
    "select": "Select",
    "showNew": "Show recent",
    "start": "Start",
    "statistics": "Statistics",
    "statusDate": "Status setting date",
    "store": "Object",
    "stores": "Objects",
    "taxAuthority": "Tax authority",
    "taxationType": "Form of taxation",
    "taxationTypes": {
      "INCOME": "Income tax",
      "PROFIT": "Profit tax",
      "SIMPLIFIED": "Simplified tax ",
      "VAT": "VAT",
      "EMPTY": "No data"
    },
    "taxes": "Taxes",
    "technical": "Technical",
    "turnover": "Turnover",
    "turnoverByActivity": "Turnover by activity",
    "turnovers": "Turnovers",
    "unblock": "Unblock",
    "update": "Update",
    "user": "User",
    "users": "Users",
    "showNextPageReports": "Next {{limit}} elements",
    "showNextPageCashboxes": "Next {{limit}} cashboxes",
    "showNextPageDevices": "Next {{limit}} tokens",
    "showNextPageDocuments": "Next {{limit}} receipts",
    "showNextPageTaxpayers": "Next {{limit}} taxpayers",
    "deregistrationDate": "Deregistration date",
    "registration": "Registration",
    "photos": "Photos",
    "upload": "Upload",
    "dropZoneText": "Drag and drop a photo here or click to choose",
    "dropZoneTitle": "Upload photos",
    "maxNumberOfPhotos": "The maximum number of photos: {{numberOfFiles}}",
    "addPhotos": "Add photos",
    "inspection": "Inspection",
    "inspections": "Inspections",
    "dropZoneMaxFilesUploaded": "Maximum number of photos is uploaded",
    "setPhotoAsPreview": "Set as preview photo",
    "photoIsPreview": "Preview photo",
    "deletePhoto": "Delete photo",
    "attachPhotos": "Please attach 1 to {{maxNumber}} photos",
    "fileSizeAndFormats": "File size is not more than {{fileSize}} MB, available formats are {{formats}}",
    "showNextPageLocations": "Next {{limit}} locations",
    "locationData": "Location data",
    "showNextPageStores": "Next {{limit}} objects",
    "showNextPageOperators": "Next {{limit}} operators",
    "result": "Result",
    "activate": "Activate",
    "eliminate": "Eliminate",
    "dropZoneDocumentsText": "Drag and drop documents here or click to choose",
    "attachDocuments": "Please attach up to {{maxNumber}} documents",
    "fileSizeAndFormatsDocuments": "Each document is not more than {{fileSize}} Mb, available formats are {{formats}}",
    "dropZoneMaxDocumentsUploaded": "Maximum number of documents is uploaded",
    "addDocuments": "Add documents",
    "addedByUser": "Added by",
    "checkSum": "Check sum",
    "creationDate": "Creation date",
    "updatedDate": "Update date",
    "inactivity": "Inactivity",
    "generalInfo": "General info",
    "additionalInfo": "Additional info",
    "country": "Country",
    "code": "Code",
    "requestDate": "Request date",
    "statusDetails": "Status details",
    "statusChangeDate": "Status change date",
    "version": "Version",
    "architecture": "Architecture",
    "change": "Change",
    "hints": {
      "incorrectStoreTaxNumber": "Invalid format of object code (10 digits - 5(7) digits).",
      "incorrectCompanyTaxNumber": "Invalid format of TIN (10 digits).",
      "incorrectCashboxTaxNumber": "Invalid format of cashbox registration number  (10 symbols).",
      "incorrectRrn": "Invalid format of RRN  (8-16 symbols).",
      "incorrectFiscalId": "Invalid format of fiscal ID (42-46 base58 symbols)."
    },
    "certificate": "Certificate",
    "registrationNumberShort": "Registration number",
    "service": "Service",
    "initialization": "Initialization",
    "addCashboxes": "Add cashboxes",
    "operationStatus": "Operation status",
    "maxNumberOfFiles": "Allowed number of files to attach: {{limit}}",
    "pictureSizeAndFormats": "Each photo is not more than {{fileSize}} Mb, available formats are {{formats}}",
    "devicesList": "Tokens list",
    "updateData": "Update data",
    "logs": "Logs",
    "environment": "Environment",
    "byDetailsLevel": "By level of detail",
    "fiscalDriverPublicKey": "Fiscal driver public key"
  },
  "errors": {
    "failedLoadList": "Failed to load list \"{{listName}}\"",
    "failedTryAgain": "Failed to execute, please try again",
    "failedUploadFile": "Failed to upload file",
    "failedUploadFileName": "Failed to download file: {{fileName}}",
    "noResultsFound": "No results found",
    "notFoundByParams": "Nothing found by applied parameters",
    "requestFailed": "Request failed",
    "somethingWrong": "Oops! Something went wrong, please try again",
    "toLessThanFrom": "The value 'To' cannot be less than the value 'From'",
    "tokenNotReceived": "User actions verification error",
    "failedUploadMaxFiles": "Failed to upload file, check the maximum number of allowed files",
    "commentNotEmpty": "The comment field must not be empty",
    "commentLengthError": "The comment length cannot be more than {{maxLength}} characters",
    "failedToGetUrl": "Failed to get URL to download the file {{fileName}}",
    "failedToDeleteFiles": "Failed to delete file(s)",
    "sameCurrentAndTargetValues": "The current and the new values are the same",
    "noMeaningfulValue": "Please enter a meaningful value."
  },
  "operator": {
    "operatorName": "Operator name",
    "operatorTaxNumber": "Operator TIN",
    "operatorTaxNumberShort": "TIN",
    "serviceOperators": "Service operators"
  },
  "store": {
    "address": {
      "building": "Building",
      "city": "City",
      "region": "Region",
      "street": "Street"
    },
    "storeAddress": "Object address",
    "storeСategories": {
      "ADVERTISING": "ADVERTISING",
      "CATERING": "CATERING",
      "COMMUNICATION": "COMMUNICATION",
      "EDUCATION": "EDUCATION",
      "ENTERTAINMENT": "ENTERTAINMENT",
      "FINANCE": "FINANCE",
      "GAS_STATION": "GAS STATION",
      "HEALTH_CARE": "HEALTH CARE",
      "HOTELS": "HOTELS",
      "OTHER": "OTHER",
      "PRODUCTION": "PRODUCTION",
      "PUBLIC_SERVICES": "PUBLIC SERVICES",
      "QUARRY": "QUARRY",
      "RENT": "RENT",
      "TICKETS": "TICKETS",
      "TRADE": "TRADE"
    },
    "storeName": "Object name",
    "storeStatus": "Object status",
    "storeStatuses": {
      "ACTIVE": "Active",
      "CLOSED": "Closed",
      "ELIMINATED": "Liquidated",
      "SUSPENDED": "Suspended"
    },
    "storeTaxAuthority": "Tax authority",
    "storeTaxNumber": "Object code",
    "storeTaxNumberShort": "Code",
    "storeType": "Activity",
    "storeWebSite": "Web site",
    "storeTypes": {
      "ADVERTISING": "Advertising services",
      "AUTO_STATION": "Bus station",
      "BANK": "Bank",
      "BEACH": "Beach",
      "BEAUTY": "Hairdresser and beauty salons",
      "CAFE": "Cafe (dining room)",
      "CAR_SERVICE": "Car service",
      "CELEBRATIONS": "Houses celebrations",
      "CEREMONIAL_SERVICES": "Ceremonial services",
      "COMMUNAL_SERVICES": "Housing and economic object",
      "COMMUNICATION": "Communication services",
      "COMPUTERS": "Activities related to a computer",
      "CONSUMERS": "Consumer services object",
      "CULTURAL": "Cultural objects",
      "DENTIST": "Dentist",
      "ENTERTAINMENT": "Objects of rest and entertainment",
      "EXCHANGE": "Currency exchange points",
      "EXHIBITIONS": "Exhibition salons",
      "GAMING": "Gambling",
      "GAS_STATION": "Gas station",
      "HEALTH_RESORT": "Health resort objects",
      "HEALTH_SERVICES": "Health services",
      "HIGH_EDUCATION": "Higher educational institution",
      "HOSPITAL": "Health center / hospital / ambulatory",
      "HOSTEL": "Hosting services",
      "HOTELS": "Hotels",
      "INSURANCE": "Insurance",
      "INTRENET_CLUB": "Internet club",
      "LEGAL_SERVICES": "Notary office / legal services",
      "MAGAZINES": "Sale of newspapers and magazines",
      "MANUFACTURING": "Manufacturing facility",
      "MARKET": "Market",
      "MOBILE_TRADE": "Mobile trade",
      "MOTEL_CAMPING": "Motel / Camping",
      "MOTEL_RESTAURANT": "Motel / Restaurant",
      "NUTRITION": "Nutrition",
      "OFFICES": "Office",
      "PARKING": "Car parks",
      "PAWNSHOP": "Pawnshop",
      "PAYMENT_TERMINALS": "Payment terminal",
      "PHARMACY": "Pharmacy / optics",
      "PHOTOS": "Photos",
      "PRESCHOOL": "Preschool educational institutions",
      "PUBLIC_CATERING": "Public catering",
      "PUBLISHING": "Publishing house",
      "QUARRY": "Quarry",
      "RENT": "Rent",
      "RESTAURANTS": "Restaurants",
      "RETAIL": "Retail",
      "SCHOOLS": "Schools and vocational schools",
      "SPORT": "Health and sport complexes",
      "STOCK": "Stock",
      "TAXI": "Taxi",
      "TEAHOUSE": "Teahouse",
      "TICKETS": "Tickets",
      "TOURISM": "Tourism excursion",
      "TRAININGS": "Training courses",
      "TRANSPORTATION": "Passenger and cargo transportation",
      "WASTE_RECEPTION": "Waste reception center",
      "WHOLESALE": "Wholesale trade"
    },
    "storeMainActivities": {
      "TRADE": "Trade",
      "CATERING_SERVICES": "Catering services",
      "OTHER_SERVICES": "Other services",
      "PRODUCTION_FACILITY_NON_FOOD": "Production facility (non-food)",
      "SPORTS_LEISURE_AND_ENTERTAINMENT_SERVICES": "Sports, leisure and entertainment services",
      "HEALTHCARE_SERVICES": "Healthcare services",
      "HOUSEHOLD_SERVICES": "Household services",
      "PRODUCTION_FACILITY_FOOD": "Production facility (food)",
      "COMMUNICATION_SERVICES": "Communication services",
      "TRAVEL_SERVICES": "Travel services",
      "PRODUCTION_FACILITY_BEVERAGES": "Production facility (beverages)",
      "PRODUCTION_FACILITY": "Production facility",
      "EDUCATION_SERVICES": "Education services",
      "TRANSPORTATION_SERVICES": "Transportation services",
      "FINANCIAL_SERVICES": "Financial services"
    },
    "storeMiddleActivities": {
      "RETAIL_TRADE": "Retail trade",
      "CAFE_RESTAURANT": "Cafе-restaurant",
      "RENTAL_FACILITY": "Rental facility",
      "CELEBRATION_HOUSE": "Celebration house",
      "CAR_SERVICE": "Car service",
      "FACTORY": "Factory",
      "WHOLESALE_TRADE": "Wholesale trade",
      "OFFICE": "Office",
      "TICKET_SALES": "Ticket sales",
      "LEISURE_AND_ENTERTAINMENT_CENTER": "Leisure and entertainment center",
      "HOSPITAL": "Hospital",
      "CULTURAL_OBJECT": "Cultural object",
      "SPORTS_CENTER": "Sports center",
      "TAILOR": "Tailor",
      "WAREHOUSE": "Warehouse",
      "WATCH_REPAIRING": "Watch repairing",
      "CEREMONY_HOUSE": "Ceremony house",
      "TELEVISION_AND_RADIO_BROADCASTING": "Television and radio broadcasting",
      "HOTEL": "Hotel",
      "DENTISTRY": "Dentistry",
      "HAIRDRESSERS_AND_BEAUTY_SALONS": "Hairdressers and beauty salons",
      "DRY_CLEANING": "Dry cleaning",
      "AGRICULTURE": "Agriculture",
      "SHOPPING_CENTER_MARKETPLACE": "Shopping center, marketplace",
      "FASHION_HOUSE_ATELIER": "Fashion house, atelier",
      "POULTRY_AND_LIVESTOCK_FARMING": "Poultry and livestock farming",
      "PHONE_REPAIR": "Phone repair",
      "TEAHOUSE": "Teahouse",
      "PRE_SCHOOL_EDUCATION": "Pre-school education",
      "MOBILE_COMMUNICATION_CUSTOMER_SERVICE": "Mobile communication customer service",
      "BUS_STATION": "Bus station",
      "TRAINING_COURSES": "Training courses",
      "MOBILE_PHONE_REPAIR": "Mobile phone repair",
      "FURNITURE_REPAIR": "Furniture repair",
      "SOCIAL_ASSISTANCE": "Social assistance",
      "MEDICAL_HEALTH_CARE_SERVICES": "Medical health care services",
      "LOMBARD": "Lombard",
      "EXHIBITION_HALL": "Exhibition hall",
      "LAUNDRY": "Laundry",
      "CAR_PARKING": "Car parking",
      "FREIGHT_TRANSPORTATION_OFFICE": "Freight transportation office",
      "RECEPTION_POINT_FOR_METALS_AND_OTHER_WASTE": "Reception point for metals and other waste",
      "WEDDING_DRESS_RENTAL": "Wedding dress rental",
      "ANIMAL_TRAINING_AND_CARE": "Animal training and care",
      "COMPUTER_REPAIR": "Computer repair",
      "COURIER_OR_DELIVERY_SERVICE": "Courier or delivery service",
      "BOILER_REPAIR": "Boiler repair",
      "JEWELLERY_SERVICES": "Jewellery services",
      "NOTARY_OFFICE_LEGAL_SERVICES": "Notary office, legal services",
      "MEDICAL_CENTER": "Medical center",
      "TELECOMMUNICATION_ACTIVITIES": "Telecommunication activities",
      "DECORATIVE_WORKS": "Decorative works",
      "RENTAL_OF_SPORTS_AND_LEISURE_GOODS": "Rental of sports and leisure goods",
      "PHOTO_STUDIO": "Photo studio",
      "CLOTHING_RENTAL": "Clothing rental",
      "COMPUTER_SERVICES": "Computer services",
      "GLASS_WASTE_COLLECTION_POINT": "Glass waste collection point",
      "INTERNET_SUPPLY_SERVICE": "Internet supply service",
      "GAMBLING": "Gambling",
      "INTERNET_CLUB": "Internet club",
      "POST_OFFICE": "Post office",
      "SHOE_REPAIR": "Shoe repair",
      "PHOTO_PRINTING_SHOP": "Photo printing shop",
      "DECORATION_OF_TRAYS": "Decoration of trays",
      "SANATORIUM": "Sanatorium",
      "EYEGLASSES_REPAIR": "Eyeglasses repair",
      "TOURIST_CAMPS_AND_RESORTS": "Tourist camps and resorts",
      "CURRENCY_EXCHANGE_POINT": "Currency exchange point",
      "VIDEO_COPYING_SERVICE": "Video copying service",
      "REPAIR_AND_PAINTING_OF_METAL_PRODUCTS": "Repair and painting of metal products",
      "DORMITORY": "Dormitory",
      "BICYCLE_REPAIR": "Bicycle repair",
      "CLEANING_SERVICE": "Cleaning service",
      "PASSENGER_TRANSPORTATION_OFFICE": "Passenger transportation office",
      "KEY_MAKING_AND_REPAIR_SERVICE": "Key making and repair service",
      "VEHICLE_AND_EQUIPMENT_REPAIR": "Vehicle and equipment repair",
      "RENTAL_OF_VIDEO_TAPES_AND_DISCS": "Rental of video tapes and discs",
      "AIRPORT": "Airport",
      "MANAGEMENT_OF_APARTMENT_BUILDINGS": "Management of apartment buildings",
      "CLOTHING_REPAIR": "Clothing repair",
      "RESORT_AREA": "Resort area",
      "REPAIR_OF_HOUSEHOLD_APPLIANCES": "Repair of household appliances",
      "TOILET": "Toilet",
      "CARPET_CLEANING": "Carpet cleaning",
      "WEDDING_CAR_DECORATION": "Wedding car decoration",
      "TURNER": "Turner",
      "HIGHER_EDUCATION": "Higher Education",
      "POTTERY_TINWORK_AND_DISHWARE_PRODUCTION": "Pottery, tinwork and dishware production",
      "PUMP_REPAIR": "Pump repair",
      "SCHOOL_VOCATIONAL_COLLEGE": "School, vocational college",
      "TINWORKER": "Tinworker",
      "FINE_ARTS": "Fine arts",
      "SHIP_REPAIR_AND_MAINTENANCE": "Ship repair and maintenance"
    },
    "storeLowerActivities": {
      "SELLING_ALCOHOLIC_BEVERAGES": "Selling alcoholic beverages",
      "SELLING_WATCHES": "Selling watches",
      "RESTAURANT": "Restaurant",
      "RENTAL_FACILITY": "Rental facility",
      "FUEL_SELLING": "Fuel selling",
      "SELLING_PETROLEUM_PRODUCTS": "Selling petroleum products",
      "FUEL_FILLING_POINTS": "Fuel filling points",
      "CELEBRATION_HOUSE": "Celebration house",
      "FOODS_SELLING": "Foods selling",
      "MARKET_NETWORK_FOOD": "Market network (food)",
      "CAR_SERVICE": "Car service",
      "SELLING_WOMEN_CLOTHING": "Selling women's clothing",
      "FURNITURE_MANUFACTURING": "Furniture manufacturing",
      "GAS_FILLING_POINTS": "Gas filling points",
      "SELLING_TOBACCO_PRODUCTS": "Selling tobacco products",
      "SECURITY_SERVICE": "Security service",
      "SELLING_BIJOUTERIE_AND_ACCESSORIES": "Selling bijouterie and accessories",
      "SELLING_STATIONERY_SUPPLIES": "Selling stationery supplies",
      "AIR_TICKET_OFFICE": "Air ticket office",
      "SELLING_MOBILE_PHONES": "Selling mobile phones",
      "SELLING_COSMETICS_AND_PERFUMERY": "Selling cosmetics and perfumery",
      "SELLING_CHILDREN_CLOTHING": "Selling children's clothing",
      "SELLING_HOUSEHOLD_GOODS": "Selling household goods",
      "PLANTS_SELLING": "Plants selling",
      "SELLING_SUGAR_CHOCOLATE_AND_CONFECTIONERY": "Selling sugar, chocolate and confectionery",
      "FOOTWEAR_SELLING": "Footwear selling",
      "BOOKS_SELLING": "Books selling",
      "GAMES_ROOM": "Games room",
      "KITCHENWARE_SELLING": "Kitchenware selling",
      "CAR_SELLING": "Car selling",
      "SOUVENIR_MANUFACTURING": "Souvenir manufacturing",
      "COFFEE_HOUSE": "Coffee house",
      "FURNITURE_SELLING": "Furniture selling",
      "SELLING_SILVER_AND_OTHER_METAL_JEWELLERY": "Selling silver and other metal jewellery",
      "CAFE": "Cafе",
      "MAIL_OR_INTERNET_SALES": "Mail or internet sales",
      "CLINIC": "Clinic",
      "CINEMA": "Cinema",
      "SELLING_MEAT_AND_MEAT_PRODUCTS": "Selling meat and meat products",
      "SPORTS_HALL": "Sports hall",
      "SELLING_HUNTING_SUPPLIES": "Selling hunting supplies",
      "SELLING_SWEETS": "Selling sweets",
      "TAILOR": "Tailor",
      "SELLING_ELECTRICAL_HOUSEHOLD_GOODS": "Selling electrical household goods",
      "CANTEEN": "Canteen",
      "SELLING_COMPUTERS": "Selling computers",
      "STORAGE_AND_WAREHOUSING_SERVICES": "Storage and warehousing services",
      "ENTERTAINMENT_CENTER": "Entertainment center",
      "PRODUCTION_OF_SAUSAGES": "Production of sausages",
      "LUMINAIRE_SELLING": "Luminaire selling",
      "CONFECTIONERY_PRODUCTION": "Confectionery production",
      "SELLING_INDUSTRIAL_GOODS": "Selling industrial goods",
      "SELLING_CONSTRUCTION_MATERIALS": "Selling construction materials",
      "TABLEWARE_SELLING": "Tableware selling",
      "SELLING_SPORTS_GOODS": "Selling sports goods",
      "SELLING_CHEMICALS": "Selling chemicals",
      "SELLING_CAR_SPARE_PARTS": "Selling car spare parts",
      "SELLING_PHARMACEUTICAL_GOODS": "Selling pharmaceutical goods",
      "FISH_RESTAURANT": "Fish restaurant",
      "JEWELLERY_SELLING": "Jewellery selling",
      "RETAIL_TRADE_OF_FERTILIZERS_SEEDS_AND_PESTICIDES": "Retail trade of fertilizers, seeds and pesticides",
      "GIFTS_SELLING": "Gifts selling",
      "WATCH_REPAIRING": "Watch repairing",
      "SELLING_ANIMALS": "Selling animals",
      "BEER_HALL": "Beer hall",
      "CEREMONY_HOUSE": "Ceremony house",
      "SELLING_DAIRY_PRODUCTS": "Selling dairy products",
      "SELLING_OPTICAL_GOODS": "Selling optical goods",
      "TRANSLATION_SERVICES": "Translation services",
      "BREAD_PRODUCTION": "Bread production",
      "PLASTICS_MANUFACTURING": "Plastics manufacturing",
      "HOTEL": "Hotel",
      "SELLING_VETERINARY_GOODS": "Selling veterinary goods",
      "PIZZA_SHOP": "Pizza shop",
      "SELLING_ANIMAL_FEED": "Selling animal feed",
      "MOTEL": "Motel",
      "DENTAL_CLINIC": "Dental clinic",
      "SELLING_CERAMICS_TILES": "Selling ceramics tiles",
      "PRODUCTION_OF_PLASTIC_DOORS_AND_WINDOWS": "Production of plastic doors and windows",
      "WOMEN_BEAUTY_SALON": "Women's beauty salon",
      "SELLING_CURTAINS": "Selling curtains",
      "PRODUCTION_OF_OTHER_MACHINERY_AND_TOOLS": "Production of other machinery, equipment and tools",
      "PUBLIC_ADMINISTRATIVE_BUILDING": "Public administrative building",
      "TOUR_OPERATOR": "Tour operator",
      "DENTAL_OFFICE": "Dental office",
      "PRODUCTION_OF_ALCOHOLIC_BEVERAGES": "Production of alcoholic beverages",
      "SELLING_HEATING_SYSTEMS": "Selling heating systems",
      "REFRACTORY_MATERIALS_MANUFACTURING": "Refractory materials manufacturing",
      "DRY_CLEANING_SERVICES": "Dry cleaning services",
      "GROWING_OTHER_PLANTS": "Growing other plants",
      "SELLING_TEXTILE_MATERIALS": "Selling textile materials",
      "SELLING_FLOUR_AND_FLOUR_PRODUCTS": "Selling flour and flour products",
      "PRODUCTION_OF_RUBBER_TYRES_TUBES_AND_PIPES": "Production of rubber tyres, tubes and pipes",
      "PRODUCTION_OF_OTHER_CONCRETE_PRODUCTS": "Production of other concrete, gypsum and cement products",
      "SOUVENIRS_SELLING": "Souvenirs selling",
      "BAGS_SELLING": "Bags selling",
      "BAR": "Bar",
      "MEN_BARBER_SHOP": "Men's barber shop",
      "SHOPPING_CENTER": "Shopping center",
      "FASHION_HOUSE_ATELIER": "Fashion house, atelier",
      "PLUMBING_EQUIPMENT_INSTALLATION_SERVICES": "Plumbing and sanitary equipment installation services",
      "SELLING_STYROFOAM": "Selling styrofoam",
      "POULTRY_FARMING": "Poultry farming",
      "PRODUCTION_OF_MILK_AND_DAIRY_PRODUCTS": "Production of milk and dairy products",
      "PHONE_REPAIR": "Phone repair",
      "SELLING_EQUIPMENT_FOR_MINING_AND_CONSTRUCTION": "Selling machines and equipment for mining and construction Works",
      "TEAHOUSE": "Teahouse",
      "TOYS_SELLING": "Toys selling",
      "MANUFACTURING_OF_OTHER_FINISHED_METAL_PRODUCTS": "Manufacturing of other finished metal products",
      "PET_SHOP": "Pet shop",
      "ADVERTISING_SERVICE": "Advertising service",
      "POLYCLINIC": "Polyclinic",
      "MANUFACTURING_OF_OTHER_FOOD_PRODUCTS": "Manufacturing of other food products not included in other groups",
      "SELLING_SCHOOL_SUPPLIES": "Selling school supplies",
      "PARK": "Park",
      "TOUR_AGENT": "Tour agent",
      "SELLING_OTHER_MACHINES_AND_EQUIPMENT": "Selling other machines and equipment",
      "SELLING_AGRICULTURAL_MACHINES_AND_EQUIPMENT": "Selling agricultural machines and equipment",
      "PRODUCTION_OF_OTHER_NON_FOOD_PRODUCTS": "Production of other non-food products",
      "PRODUCTION_OF_FLOUR_MILLING_INDUSTRY_PRODUCTS": "Production of flour milling industry products",
      "PRODUCTION_OF_MEN_CLOTHING": "Production of men's clothing",
      "PRODUCTION_OF_COMBI_RADIATORS": "Production of combi radiators",
      "CATERING_SERVICE": "Catering service",
      "SELLING_ROOF_COVERINGS": "Selling roof coverings",
      "BEACH": "Beach",
      "TANDOOR_OVEN": "Tandoor oven",
      "REPAIR_OF_OTHER_PRODUCTS_EQUIPMENT_AIRCRAFTS": "Repair of other products, equipment, aircrafts",
      "SELLING_SANITARY_GOODS": "Selling sanitary goods",
      "FLOUR_PRODUCTION": "Flour production",
      "SELLING_MEDICAL_AND_ORTHOPAEDIC_GOODS": "Selling medical and orthopaedic goods",
      "SPA_SALON": "Spa salon",
      "HAZELNUT_PROCESSING": "Hazelnut processing",
      "GYM_FITNESS_HALL": "Gym (fitness) hall",
      "NEWSPAPER_STAND": "Newspaper stand",
      "FOOTBALL_FIELD": "Football field",
      "SELLING_OTHER_PHONES": "Selling other phones",
      "PRODUCTION_OF_PILLOWS_MATTRESSES": "Production of pillows, mattresses and similar items",
      "PRODUCTION_OF_PLASTIC_BAGS": "Production of plastic bags",
      "PRODUCTION_OF_CHEMICAL_PRODUCTS": "Production of chemical products",
      "LIMESTONE_AND_GYPSUM_MINING": "Limestone and gypsum mining",
      "SELLING_FLOWERS": "Selling flowers",
      "PRODUCTION_OF_MARBLE": "Production of marble",
      "PRODUCTION_OF_PACKAGING_FROM_OTHER_MATERIALS": "Production of packaging from other materials",
      "CARPETS_SELLING": "Carpets selling",
      "SELLING_AUDIO_AND_VIDEO_EQUIPMENT": "Selling audio and video equipment",
      "INSTALLATION_ELECTRIC_HEATING_SYSTEMS": "Installation services for electric heating systems",
      "SELLING_TELECOMMUNICATION_EQUIPMENT": "Selling telecommunication equipment",
      "GLASS_SELLING": "Glass selling",
      "FODDER_PRODUCTION": "Fodder production",
      "RETAIL_SELLING_NON_ALCOHOLIC_BEVERAGES": "Retail selling of non-alcoholic beverages",
      "WALLPAPER_SELLING": "Wallpaper selling",
      "PRODUCTION_OF_PARQUET_FLOORING": "Production of parquet flooring",
      "KINDERGARTEN": "Kindergarten",
      "CAR_MARKET": "Car market",
      "SELLING_WOODEN_MATERIALS": "Selling wooden materials",
      "MOBILE_COMMUNICATION_CUSTOMER_SERVICE": "Mobile communication customer service",
      "SELLING_FERTILISERS_AND_AGROCHEMICAL_PRODUCTS": "Selling fertilisers and agrochemical products",
      "OPERATION_OF_BUS_STATIONS": "Operation of bus stations",
      "TRAINING_CENTER": "Training center",
      "SURGERY_ROOM": "Surgery room",
      "ICE_CREAM_PRODUCTION": "Ice-cream production",
      "SELLING_NUTRITIONAL_SUPPLEMENTS": "Selling nutritional supplements",
      "METAL_PROCESSING_AND_COATING": "Metal processing and coating",
      "PRODUCTION_OF_CRACKERS_AND_COOKIES": "Production of crackers and cookies",
      "PAPER_AND_CARDBOARD_PRODUCTION": "Paper and cardboard production",
      "MANUFACTURING_OF_CONFECTIONERY_FROM_SUGAR": "Manufacturing of confectionery products from sugar",
      "CUSTOMS_WAREHOUSES_STORAGES_FREE_WAREHOUSES": "Establishment of customs warehouses, temporary storages, free warehouses",
      "FOOTWEAR_PRODUCTION": "Footwear production",
      "SELLING_PAINT_AND_VARNISH_MATERIALS": "Selling paint and varnish materials",
      "GREENHOUSE": "Greenhouse",
      "INSTALLATION_HEATING_VENTILATION_AIR_CONDITIONING_SYSTEMS": "Installation services for heating, ventilation, air conditioning systems",
      "CATTLE_BREEDING": "Cattle breeding",
      "FRUIT_AND_VEGETABLES_SELLING": "Fruit and vegetables selling",
      "PRODUCTION_OF_NON_ALCOHOLIC_BEVERAGES": "Production of non-alcoholic beverages",
      "SUGAR_PRODUCTION": "Sugar production",
      "MEDICAL_OFFICE": "Medical office",
      "PRODUCTION_OF_MEAT_PRODUCTS": "Production of meat products",
      "MOBILE_PHONE_REPAIR": "Mobile phone repair",
      "FURNITURE_REPAIR": "Furniture repair",
      "BATHHOUSE": "Bathhouse",
      "CAKE_PRODUCTION": "Cake production",
      "SELLING_METAL_AND_METAL_PRODUCTS": "Selling metal and metal products",
      "PRINTING_HOUSE": "Printing house",
      "TIRE_SERVICE": "Tire service",
      "CARE_FOR_PERSONS_WITH_ALCOHOL_AND_DRUG_ABUSE_PROBLEMS": "Care for persons with mental disorders or physical disabilities caused by alcohol and drug abuse",
      "MEDICAL_HEALTH_CARE_SERVICES": "Medical health care services",
      "PRODUCTION_OF_PAINT_SUBSTANCES_AND_PIGMENTS": "Production of paint substances and pigments",
      "SELLING_FLOUR": "Selling flour",
      "COSMETOLOGY_CENTER": "Cosmetology center",
      "BROADCASTING_ACTIVITY": "Broadcasting activity",
      "CONSTRUCTION_OF_BUILDINGS": "Construction of residential and non-residential buildings",
      "AESTHETIC_MEDICINE_CENTER": "Aesthetic medicine center",
      "CHESS_TRAINING": "Chess training",
      "MUSEUM": "Museum",
      "SELLING_BOTTLED_DRINKING_WATER": "Selling bottled drinking water",
      "LOMBARD": "Lombard",
      "PRODUCTION_OF_PAINTS_VARNISHES_PRINTING_INKS_AND_MASTICS": "Production of paints, varnishes and similar coatings, printing inks and mastics",
      "INSTALL_ALARM_SYSTEMS_LIGHTNING_RODS_LIGHTING_ANTENNAS": "Installation services for anti-theft alarm systems, lightning rods, lighting systems, antennas",
      "ART_WORKSHOP": "Art workshop",
      "CAR_SHOWROOM": "Car showroom",
      "SHAWARMA": "Shawarma",
      "NIGHT_ENTERTAINMENT_CLUB": "Night entertainment club",
      "BUSINESS_AND_MANAGEMENT_CONSULTING_SERVICES": "Business and management consulting services",
      "LABORATORY": "Laboratory",
      "FLORICULTURE_SEED_PRODUCTION": "Floriculture, seed production",
      "PRODUCTION_OF_CONCRETE": "Production of concrete",
      "PRODUCTION_OF_SEWING_THREADS": "Production of sewing threads",
      "CEMENT_SELLING": "Cement selling",
      "LAUNDRY": "Laundry",
      "CAR_PARKING": "Car parking",
      "WHOLESALE_AGENCY_SERVICES": "Wholesale agency services",
      "LAHMACUN_TURKISH_PIZZA": "Lahmacun (turkish pizza)",
      "FREIGHT_TRANSPORTATION_OFFICE": "Freight transportation office",
      "FABRICATION_OF_DENTAL_PROSTHESES": "Fabrication of dental prostheses",
      "PRODUCTION_OF_BEE_PRODUCTS": "Production of bee products",
      "SERVICES_RELATED_TO_PRINTING_WORKS": "Services related to printing works",
      "RENTAL_HOUSING": "Rental housing",
      "SELLING_MACHINE_TOOLS": "Selling machine tools",
      "RECEPTION_POINT_FOR_METALS_AND_OTHER_WASTE": "Reception point for metals and other waste",
      "POTTERY_PRODUCTION": "Pottery production",
      "PRODUCTION_OF_SOAPS_DETERGENTS_AND_CLEANING_AGENTS": "Production of soaps, detergents and cleaning agents",
      "PRODUCTION_OF_WOODEN_CRATES_BOXES": "Production of wooden crates (boxes)",
      "WEDDING_DRESS_RENTAL": "Wedding dress rental",
      "CAR_OIL_CHANGE_SERVICE": "Car oil change service",
      "PRODUCTION_OF_REFRIGERATORS_AND_VENTILATION_EQUIPMENT": "Production of refrigerators and ventilation equipment",
      "GROWING_FRUIT_TREE_AND_VEGETABLE_SEEDLINGS": "Growing fruit tree and vegetable seedlings",
      "CONSULTATION_AND_DIAGNOSTIC_CENTER": "Consultation and diagnostic center",
      "ANIMAL_TRAINING_AND_CARE_SERVICES": "Animal training and care services",
      "KARAOKE_CLUB": "Karaoke club",
      "CAR_WASH_SERVICE": "Car wash service",
      "SELLING_AUDIO_AND_VIDEO_RECORDINGS": "Selling audio and video recordings",
      "PRODUCTION_OF_WIRE_PRODUCTS": "Production of wire products",
      "COMPUTER_REPAIR": "Computer repair",
      "COURIER_OR_DELIVERY_SERVICE": "Courier or delivery service",
      "DRYWALL_SELLING": "Drywall selling",
      "POTATO_CULTIVATION": "Potato cultivation",
      "PRODUCTION_OF_LOCKS_AND_HINGES": "Production of locks and hinges",
      "FURNITURE_SHOWROOM": "Furniture showroom",
      "BOILER_REPAIR": "Boiler repair",
      "JEWELRY_WORKSHOP": "Jewelry workshop",
      "PRODUCTION_OF_FISH_PRODUCTS": "Production of fish products",
      "CONSTRUCTION_MATERIALS_MARKET": "Construction materials market",
      "SELLING_COFFEE_TEA_COCOA_AND_SPICES": "Selling coffee, tea, cocoa and spices",
      "MANUFACTURE_OF_SAWN_TIMBER": "Manufacture of sawn timber",
      "SELLING_SAND_AND_GRAVEL": "Selling sand and gravel",
      "IRON_GATES_PRODUCTION": "Iron gates production",
      "CULTIVATION_OF_OTHER_FRUITS": "Cultivation of other fruits",
      "BASIC_TECHNOLOGICAL_PROCESSES_OF_MECHANICAL_ENGINEERING": "Basic technological processes of mechanical engineering",
      "CUSTOMS_SERVICES": "Customs services",
      "SUSHI": "Sushi",
      "INSTALLATION_OF_ELECTRICAL_NETWORKS_AND_EQUIPMENT": "Services on installation of electrical networks and equipment",
      "ACTIVITIES_IN_THE_FIELD_OF_ARCHITECTURE": "Activities in the field of architecture",
      "PACKAGING_SERVICES": "Packaging services",
      "LOCAL_SELF_GOVERNANCE_ACTIVITIES": "Local self-governance activities",
      "CAR_RENTAL_SERVICES": "Car rental services",
      "OTHER_EDUCATIONAL_SERVICES": "Other educational services",
      "CHILDREN_HAIRDRESSING": "Children's hairdressing",
      "GLASS_PRODUCTION": "Glass production",
      "STONE_PRODUCTION": "Stone production",
      "METAL_CASTING_AND_PRODUCTION_OF_VARIOUS_EQUIPMENT": "Metal casting and production of various equipment",
      "PRODUCTION_OF_VARIOUS_CLOTHING": "Production of various clothing",
      "PRODUCTION_OF_CAST_IRON_STEEL_AND_FERROALLOYS": "Production of cast iron, steel and ferroalloys",
      "HOSTEL": "Hostel",
      "LAW_CONSULTING_OFFICE": "Law consulting office",
      "PSYCHOLOGICAL_CENTER": "Psychological center",
      "TELECOMMUNICATION_ACTIVITIES": "Telecommunication activities",
      "GIFT_DECORATING_AND_WRAPPING_SERVICES": "Gift decorating and wrapping services",
      "WATER_PRODUCTION": "Water production",
      "PRODUCTION_OF_FRUIT_AND_VEGETABLE_JUICES": "Production of fruit and vegetable juices",
      "ATTRACTIONS_AND_WATER_PARKS": "Attractions and water parks",
      "FOOTBALL_SCHOOL": "Football school",
      "SPICE_PRODUCTION": "Spice production",
      "GUEST_HOUSE": "Guest house",
      "TOMATO_PRODUCTION": "Tomato production",
      "STONE_QUARRY": "Stone quarry",
      "RENTAL_OF_SPORTS_AND_LEISURE_GOODS": "Rental of sports and leisure goods",
      "WEDDING_PHOTO_STUDIO": "Wedding photo studio",
      "ADHESIVE_PRODUCTION": "Adhesive production",
      "SAND_AND_GRAVEL_QUARRY": "Sand and gravel quarry",
      "SELLING_SPARE_PARTS": "Selling spare parts",
      "SELLING_MEN_CLOTHING": "Selling men's clothing",
      "PHOTO_STUDIO": "Photo studio",
      "PRODUCTION_OF_METAL_PIPES": "Production of metal pipes",
      "PRODUCTION_OF_TANKS_BUCKETS_AND_CONTAINERS": "Production of tanks, buckets and containers",
      "TAX_SERVICE": "Tax service",
      "BLACKSMITH": "Blacksmith",
      "ZOO": "Zoo",
      "PRODUCTION_OF_LAVASH_BREAD": "Production of lavash bread",
      "GROCERY_MARKET": "Grocery market",
      "QUTAB_HOUSE_FLATBREAD": "Qutab house (flatbread)",
      "MANUFACTURE_OF_CLOTHING_FOR_INDUSTRIAL_FACILITIES": "Manufacture of clothing for industrial facilities",
      "RENTAL_OF_OTHER_CLOTHES": "Rental of other clothes",
      "PRODUCTION_OF_PLASTIC_SHEETS_STRIPS_PIPES_AND_PROFILES": "Production of plastic sheets, strips, pipes and profiles",
      "COMPUTER_SERVICES": "Computer services",
      "AUDIT_SERVICES": "Audit services",
      "SELLING_COCKTAILS": "Selling cocktails",
      "REALTOR_SERVICES": "Realtor services",
      "MANUFACTURE_OF_OTHER_RUBBER_PRODUCTS": "Manufacture of other rubber products",
      "PRODUCTION_OF_BRICKS_TILES_FIRED_CLAY_BUILDING_MATERIALS": "Production of bricks, tiles and other fired clay building materials",
      "GLASS_WASTE_COLLECTION_POINT": "Glass waste collection point",
      "PREPARATORY_COURSES_FOR_UNIVERSITY_ENTRANTS_ABITURIENTS": "Preparatory courses for university entrants (abiturients)",
      "PRODUCTION_OF_STYROFOAM_EXPANDED_POLYSTYRENE": "Production of styrofoam (expanded polystyrene)",
      "PRODUCTION_OF_CABLES": "Production of cables",
      "PILATES_CENTER": "Pilates center",
      "COMPUTER_COURSES": "Computer courses",
      "PRODUCTION_OF_PASTA_NOODLES_AND_SIMILAR_PRODUCTS": "Production of pasta, noodles and similar products",
      "PATIENT_CARE": "Patient care",
      "PRODUCTION_OF_CONFECTIONERY_PRODUCTS": "Production of confectionery products",
      "INTERNET_PROVIDER_SERVICES": "Internet provider services",
      "SPORTS_AND_FITNESS_CENTER": "Sports and fitness center",
      "TOPAZ_AREA_REGION": "Topaz area (region)",
      "CAR_DIAGNOSTICS": "Car diagnostics",
      "INTERNET_CLUB": "Internet club",
      "POST_OFFICE": "Post office",
      "SHOE_REPAIR": "Shoe repair",
      "CULTIVATION_OF_SPICES_PERFUME_PLANTS_AND_MEDICINAL_HERBS": "Cultivation of spices, perfume plants and medicinal herbs",
      "TRANSLATION_AGENCY": "Translation agency",
      "PHOTO_PRINTING_SHOP": "Photo printing shop",
      "DECORATION_OF_TRAYS": "Decoration of trays",
      "BATTERY_PRODUCTION": "Battery production",
      "PRODUCTION_OF_FRUIT_AND_VEGETABLE_SNACKS": "Production of fruit and vegetable snacks",
      "CANDY_STORE": "Candy store",
      "PIE_SHOP": "Pie shop",
      "CAR_TUNING": "Car tuning",
      "CHILD_DEVELOPMENT_CENTRE": "Child development center",
      "SANATORIUM": "Sanatorium",
      "ACCOMMODATION_SERVICES": "Accommodation services",
      "LOGOPEDIST_SERVICES": "Logopedist services",
      "SHEEP_AND_GOATS_BREEDING": "Sheep and goats breeding",
      "COMPUTER_HALL": "Computer hall",
      "REPAIR_AND_PRODUCTION_OF_AGRICULTURAL_AND_FORESTRY_TRACTORS": "Repair and production of agricultural and forestry tractors",
      "EYEGLASSES_REPAIR": "Eyeglasses repair",
      "STONE_MARKET": "Stone market",
      "PRODUCTION_OF_WOMEN_CLOTHING": "Production of women's clothing",
      "PRODUCTION_OF_OILS_AND_FATS": "Production of oils and fats",
      "SPEECH_DEVELOPMENT_CENTER": "Speech development center",
      "BLINDS_PRODUCTION": "Blinds production",
      "TOURIST_CAMPS": "Tourist camps",
      "TURNING_WORK": "Turning work",
      "PRODUCTION_OF_CHILDREN_CLOTHING": "Production of children's clothing",
      "COVER_REPAIR": "Cover repair",
      "PRODUCTION_OF_TOMBSTONES": "Production of tombstones",
      "ART_GALLERY": "Art gallery",
      "DESIGN_COURSES": "Design courses",
      "PRODUCTION_OF_WINES_AND_WINE_MATERIALS": "Production of wines and wine materials",
      "CURRENCY_EXCHANGE_OFFICE": "Currency exchange office",
      "VIDEO_COPYING_SERVICE": "Video copying service",
      "BREWING": "Brewing",
      "WASTE_TREATMENT_AND_DISPOSAL": "Waste treatment and disposal",
      "PRODUCTION_OF_NAPKINS": "Production of napkins",
      "REPAIR_OF_METAL_PRODUCTS": "Repair of metal products",
      "PRODUCTION_OF_SEALS_AND_STAMPS": "Production of seals and stamps",
      "SELLING_NON_ALCOHOLIC_BEVERAGES": "Selling non-alcoholic beverages",
      "EDUCATION_SERVICES": "Education services",
      "DESIGN_WORK": "Design work",
      "PRODUCTION_OF_MOLDED_DECOR": "Production of molded decor",
      "PRODUCTION_OF_STATIONERY_SUPPLIES": "Production of stationery supplies",
      "DORMITORY_SERVICES": "Dormitory services",
      "WOMEN_COUNSELLING_CENTER": "Women's counselling center",
      "PRODUCTION_OF_AUTOMOTIVE_PAINTS": "Production of automotive paints",
      "BICYCLE_REPAIR": "Bicycle repair",
      "CHEESE_AND_CURD_PRODUCTION": "Cheese and curd production",
      "SELLING_COMPUTERS_PERIPHERAL_DEVICES_AND_SOFTWARE": "Selling computers, peripheral devices and software",
      "TEXTILE_PRODUCTION": "Textile production",
      "PRODUCTION_OF_HOSIERY": "Production of hosiery",
      "SELLING_BABY_FOOD": "Selling baby food",
      "LIBRARY": "Library",
      "CLEANING_SERVICE": "Cleaning service",
      "PRODUCTION_OF_CLOTHING_ACCESSORIES": "Production of clothing accessories",
      "VOCATIONAL_TRAINING_COURSES": "Vocational training courses",
      "ADVISORY_SERVICES_FOR_AGRONOMISTS_AND_OTHER": "Advisory services for agronomists, agricultural economists and farmers",
      "BILLIARD_ROOM": "Billiard room",
      "SELLING_GOLD": "Selling gold",
      "MASSAGE_SALON": "Massage salon",
      "SERVICES_FOR_PLANNING_EFFICIENCY_CONTROL": "Services for planning, organization, ensuring efficiency and control, provision of information to management and other commercial organisations and public services.",
      "SELLING_EGGS": "Selling eggs",
      "CLEANING_OF_BUILDINGS": "Cleaning of buildings",
      "SHOOTING_CENTER": "Shooting center",
      "PAINTING_OF_METAL_PRODUCTS": "Painting of metal products",
      "PASSENGER_TRANSPORTATION_OFFICE": "Passenger transportation office",
      "PRODUCTION_OF_WOODEN_DOORS_AND_WINDOWS": "Production of wooden doors and windows",
      "SWIMMING_COMPLEX": "Swimming complex",
      "WELDER": "Welder",
      "PRODUCTION_OF_STRONG_DRINKS": "Production of strong drinks, spirits, liqueur and vodka products and materials for their production",
      "LABOUR_SUPPLY_ACTIVITIES": "Labour supply activities",
      "ALUMINIUM_PRODUCTION": "Aluminium production",
      "COFFEE_PRODUCTION": "Coffee production",
      "KEY_MAKING_AND_REPAIR": "Key making and repair",
      "FIREWOOD_PRODUCTION": "Firewood production",
      "PRE_SCHOOL_TRAINING": "Pre-school training",
      "GAS_PRODUCTION": "Gas production",
      "GARAGE": "Garage",
      "CATTLE_MARKET": "Cattle market",
      "REPAIR_OF_MACHINES_AND_EQUIPMENT": "Repair of machines and equipment",
      "EMPLOYMENT_CENTER": "Employment center",
      "CARING_FOR_ELDERLY_AND_DISABLED_PEOPLE": "Caring for elderly and disabled people",
      "LOTTERY_GAMES": "Lottery games",
      "RENTAL_OF_VIDEO_TAPES_AND_DISCS": "Rental of video tapes and discs",
      "ACCOUNTING_SERVICES": "Accounting services",
      "PRODUCTION_OF_ELECTRIC_LAMPS_AND_LIGHTING_EQUIPMENT": "Production of electric lamps and lighting equipment",
      "WALLPAPER_PRODUCTION": "Wallpaper production",
      "AIRPORT_OPERATIONS": "Airport operations",
      "MANAGEMENT_OF_APARTMENT_BUILDINGS": "Management of apartment buildings",
      "TOURIST_BASES": "Tourist bases",
      "INDUSTRIAL_GOODS_MARKET": "Industrial goods market",
      "PRODUCTION_OF_MUSICAL_INSTRUMENTS": "Production of musical instruments",
      "MANUFACTURE_OF_OTHER_WOODEN_PRODUCTS": "Manufacture of other wooden products",
      "FOREIGN_LANGUAGE_COURSES": "Foreign language courses",
      "BICYCLE_PRODUCTION": "Bicycle production",
      "CONSTRUCTION_OF_RESIDENTIAL_BUILDINGS": "Construction of residential buildings",
      "CLOTHING_REPAIR": "Clothing repair",
      "PRODUCTION_OF_LEMONADE": "Production of lemonade",
      "DANCE_STUDIO": "Dance studio",
      "FAIR": "Fair",
      "INSTALLATION_SERVICES_OF_FIRE_ALARM_SYSTEMS": "Installation services of fire alarm systems",
      "RESORT_AREA": "Resort area",
      "SELLING_GAS_PRODUCTS": "Selling gas products",
      "SELLING_LIFTING_EQUIPMENT": "Selling lifting equipment",
      "PRODUCTION_OF_GATES": "Production of gates",
      "FISH_FARMING": "Fish farming",
      "SAUNA": "Sauna",
      "PRODUCTION_OF_ESSENTIAL_OILS": "Production of essential oils",
      "TILE_PRODUCTION": "Tile production",
      "CONSULTING_SERVICES_IN_PUBLIC_RELATIONS_AND_INFORMATION": "Consulting services in the field of public relations and information sharing",
      "TOYS_PRODUCTION": "Toys production",
      "CAR_DRY_CLEANING": "Car dry cleaning",
      "REPAIR_OF_HOUSEHOLD_APPLIANCES": "Repair of household appliances",
      "PRODUCTION_OF_CHOCOLATE": "Production of chocolate",
      "TOILET": "Toilet",
      "PRODUCTION_OF_PAPER_BAGS": "Production of paper bags",
      "WEAVING": "Weaving",
      "PRODUCTION_OF_TOBACCO_PRODUCTS": "Production of tobacco products",
      "CARPET_CLEANING": "Carpet cleaning",
      "SELLING_CHOCOLATE": "Selling chocolate",
      "PROVISION_OF_SERVICES_TO_THE_MINING_INDUSTRY": "Provision of services to the mining industry",
      "CAR_PRODUCTION": "Car production",
      "WEDDING_CAR_DECORATION": "Wedding car decoration",
      "PEAT_EXTRACTION": "Peat extraction",
      "PROVISION_OF_OTHER_SOCIAL_SERVICES_WITHOUT_HOUSING": "Provision of other social services without housing, not included in other groups",
      "MANUFACTURE_OF_CARPETS_AND_CARPETING_PRODUCTS": "Manufacture of carpets and carpeting products",
      "ACTIVITIES_OF_INFORMATION_AGENCIES": "Activities of information agencies",
      "TURNER": "Turner",
      "PUBLISHERS": "Publishers",
      "MUSIC_LESSONS": "Music lessons",
      "TEA_LEAF_CULTIVATION": "Tea leaf cultivation",
      "MANUFACTURE_OF_LEATHER_AND_LEATHER_GOODS": "Manufacture of leather and leather goods",
      "STATE_ADMINISTRATIVE_BUILDING": "State administrative building",
      "RESEARCH_SERVICES_IN_NATURAL_AND_TECHNICAL_SCIENCES": "Other research services in the natural and technical sciences",
      "PRODUCTION_OF_PERFUMES_AND_COSMETICS": "Production of perfumes and cosmetics",
      "PRODUCTION_OF_ELECTRONIC_COMPONENTS": "Production of electronic components",
      "MEAT_MARKET": "Meat market",
      "FERTILISER_PRODUCTION": "Fertiliser production",
      "PAINTING_COURSE": "Painting course",
      "SKI_SLOPES_OPERATIONS": "Ski slopes operations",
      "EXPLOITATION_OF_DANCE_FLOORS": "Exploitation of dance floors",
      "SELLING_FUR_AND_LEATHER_GOODS": "Selling fur and leather goods",
      "ACADEMY": "Academy",
      "SELLING_CONFECTIONERY": "Sale of confectionery",
      "CHILDREN_PHOTO_STUDIO": "Children's photo studio",
      "PRODUCTION_OF_SUNFLOWER_SEEDS": "Production of sunflower seeds",
      "PUMP_REPAIR": "Pump repair",
      "ACCOUNTING_COURSES": "Accounting courses",
      "PRODUCTION_OF_PETROLEUM_PRODUCTS": "Production of petroleum products",
      "BREEDING_OF_OTHER_ANIMALS": "Breeding of other animals",
      "SCHOOL": "School",
      "PRODUCTION_OF_ELECTRIC_MOTORS_GENERATORS_TRANSFORMERS": "Production of electric motors, generators and transformers",
      "PRODUCTION_OF_LEGUME_CROPS": "Production of legume crops",
      "PRODUCTION_OF_DIETARY_FOODS": "Production of dietary foods",
      "TIN_WORKER": "Tin worker",
      "RESTORATION_OF_FINE_ART_WORKS": "Restoration of fine art works",
      "CAMPING": "Camping",
      "THEATER": "Theater",
      "MANUFACTURE_OF_KNIFE_PRODUCTS": "Manufacture of knife products",
      "GOAT_BREEDING": "Goat breeding",
      "HAIR_TRANSPLANTATION_CENTER": "Hair transplantation center",
      "REPAIR_AND_MAINTENANCE_OF_VESSELS": "Repair and maintenance of vessels",
      "SELLING_MUSICAL_INSTRUMENTS": "Selling musical instruments",
      "POST_PRODUCTION_EDITING_FILMS_VIDEO_AND_TV_PROGRAMS": "Post-production (editing) of films, video and TV programs",
      "CLINIC_HOSPITAL": "Clinic hospital",
      "HOSPITAL": "Hospital",
      "COPPERWORKING": "Copperworking",
      "CONSULTING_SERVICES_IN_VARIOUS_AREAS": "Consulting services in various areas",
      "ORGANIZATION_OF_CONGRESSES_AND_PROFESSIONAL_EXHIBITIONS": "Organization of congresses and professional exhibitions",
      "PREPARATION_OF_CERAMIC_PRODUCTS": "Preparation of ceramic products",
      "PRODUCTION_OF_CERAMIC_PRODUCTS": "Production of ceramic products",
      "BUSINESS_AND_MANAGEMENT_SERVICES": "Business and management services"
    },
    "storeActivityLevelsOfDetail": {
      "general": "General",
      "main": "High",
      "middle": "Middle",
      "lower": "Low"
    },
    "storeActivityByLevelsOfDetail": "Activity by levels of detail"
  },
  "user": {
    "accessRights": "Access rights",
    "deactivationDate": "Deactivation date",
    "email": "Email",
    "firstName": "First name",
    "lastName": "Last name",
    "middleName": "Middle name",
    "mobilePhone": "Mobile number",
    "password": "Password",
    "phone": "Phone number",
    "roles": "Roles",
    "roleTypes": {
      "CENTRAL_INSPECTOR": "Central inspector",
      "DIRECTOR": "Director",
      "EXPERT": "Expert",
      "AUDITOR": "Auditor",
      "INSPECTOR": "Inspector",
      "OPERATOR": "Operator",
      "TAXPAYER": "Taxpayer",
      "REGIONAL_INSPECTOR": "Regional inspector",
      "ADMIN": "Administrator"
    },
    "userName": "Name",
    "userRoles": "User roles",
    "userStatus": "User status",
    "userStatuses": {
      "ACTIVE": "Active",
      "DELETED": "Deleted",
      "INACTIVE": "Inactive"
    },
    "verificationCode": "Verification code",
    "additionalUserRoles": "Additional roles",
    "userRole": "User role"
  },
  "inspection": {
    "productName": "Name of the purchased product",
    "inspectionResult": "Inspection result",
    "completionDate": "Inspection completion date",
    "resultComment": "Auditor's comment on the inspection result",
    "errors": {
      "createInspectionError": "Failed to appoint an inspection",
      "notClosedInspectionAlreadyExists": "You cannot appoint a new inspection until the existing one is closed",
      "cancelInspectionError": "Failed to cancel the inspection",
      "assignInspectionError": "Failed to mark the inspection as taken to work",
      "emptyResult": "Select some inspection result",
      "completeInspectionError": "Failed to complete the inspection",
      "inspectionDateError": "The date and time of the inspection cannot be greater than the current time",
      "productNameError": "A name of the purchased product can not be an empty string and shall be up to {{maxLength}} characters"
    },
    "inspectionsHistory": "History of object inspections",
    "createInspection": "Appoint inspection",
    "assignInspection": "Take to work",
    "completeInspection": "Complete inspection",
    "cancelInspection": "Cancel inspection",
    "inspectionInitiatorComment": " Comment of the inspection initiator",
    "confirmCancelInspection": "Do you really want to cancel the inspection?",
    "confirmAssignInspection": "Do you really want to take the inspection to work?",
    "assignedDate": "Taken to work at",
    "initiator": "Initiator",
    "inspectionStatuses": {
      "OPEN": "Open",
      "IN_PROGRESS": "In progress",
      "CLOSED": "Closed"
    },
    "inspectionResults": {
      "RECEIPT_OK": "Receipt provided",
      "NO_RECEIPT": "Receipt not provided",
      "STORE_CLOSED": "Object closed",
      "STORE_NOT_FOUND": "Object not found",
      "CASHBOX_NOT_FOUND": "There is no cashbox"
    },
    "inspectionDate": "Date of inspection",
    "inspectionPeriod": "Inspection period",
    "inspectionStatus": "Inspection status"
  },
  "downloadings": {
    "delayedDownloadings": "Delayed downloads",
    "errors": {
      "failedToGetDelayedDownloadings": "Failed to get a list of delayed downloads",
      "failedToPollDelayedDownloadings": "Failed to poll a list of delayed downloads",
      "requestToCreateFileFailed": "Request to create the file failed. Please check the restrictions of delayed downloads list"
    },
    "downloadingTypes": {
      "OPERATORS": "Operators",
      "COMPANIES": "Taxpayers",
      "STORES": "Objects",
      "CASHBOXES": "Cashboxes",
      "DOCUMENTS": "Receipts",
      "DEVICES": "Tokens",
      "REPORT_CASH_BOX_DAY": "Report by days",
      "REPORT_CASH_BOX": "Report by cashboxes"
    },
    "downloadingStatuses": {
      "CREATED": "Requested",
      "IN_PROGRESS": "In progress",
      "READY": "Ready",
      "ERROR": "Error"
    },
    "downloadingErrors": {
      "MAX_ROWS_COUNT": "Excel file format error. Number of rows limit exceeded"
    },
    "downloadingRequestedDate": "Request date",
    "limitationsHintDays": "The storage period for files prepared for download is {{limit}} days",
    "limitationsHintItems": "The maximum number of files is {{limit}}",
    "fileCreationRequestAccepted": "File creation request accepted. Please refer to the list of delayed downloads"
  },
  "ServiceScreen": {
    "hints": {
      "onlinePhisicalFDVersion": "The operation is available for cashboxes of physical type, online mode, fiscal driver version is {{param}} or later",
      "onlinePhisicalOrSoftwareFDVersion": "The operation is available for cashboxes of physical or software type, online mode, fiscal driver version is {{param}} or later",
      "addCashboxesForOperation": "Add cashboxes to perform the operation",
      "addCashboxes": "Add cashboxes please",
      "limitForNumberOfCashboxes": "You can add up to {{limit}} cashboxes",
      "limitForOneCashbox": "You can add just one up cashbox",
      "showOperationData": "Show operation data",
      "selectTargetVersion": "Select target version",
      "deleteAllCashboxes": "Delete all cashboxes",
      "deleteCashbox": "Delete the cashbox",
      "operationSuccessful": "The operation is completed successfully",
      "performOperationConfirmation": "Do you really want to perform the operation \"{{operationType}}\" for the selected tokens?",
      "deviceAlreadyInList": "This token is already added to the list",
      "deleteAllDevices": "Delete all tokens",
      "addDevices": "Add tokens to perform the operation",
      "minFwVertionForOperation": "Firmware version is {{param}} or later",
      "limitForNumberOfDevices": "You can add up to {{limit}} tokens",
      "selectAllCashboxesForOperation": "Select all cashboxes to perform the operation",
      "selectCashboxForOperation": "Select the cashbox to perform the operation"
    },
    "errors": {
      "failedToCreateCashboxesTasks": "Failed to request the operation for cashboxes list",
      "failedToGetCashboxesTasksStatuses": "Failed to get status of the operation for cashboxes list",
      "failedToLoadFactoryNumbersList": "Failed to load factory numbers list"
    },
    "dropZoneText": "Drag and drop .csv or .json file here or click to choose",
    "initialisationOperationsTypes": {
      "PRODUCE": "Produce",
      "RESERVE": "Reserve",
      "UNRESERVE": "Unreserve",
      "USB_TYPE": "Usb type"
    },
    "serviceOperationTypes": {
      "BREAK": "Break",
      "UNBREAK": "Unbreak",
      "LOSE": "Lose",
      "LOSE_ROLLBACK": "Unlose",
      "SUPPORT": "To service",
      "SUPPORT_ROLLBACK": "Unsupport",
      "DELETE": "Delete"
    },
    "addDeviceToList": "Add a token to the list",
    "serviceOperations": "Other service operations",
    "deviceInitialization": "Token initialization",
    "enterPinCode": "Enter PIN code, please",
    "pinCode": "PIN code",
    "dumpOperationTitle": "Dump data from token",
    "saveDump": "Save dump",
    "allowWithDocumentUnsent": "Allow with unsent receipt",
    "allowWithShiftOpened": " Allow without closing the shift",
    "repairOperationTitle": "Token repair",
    "repairDevice": "Repair token",
    "newAdminPinCode": "New admin PIN code",
    "newAdminPukCode": "New admin PUK code",
    "newUserPinCode": "New user PIN code",
    "newUserPukCode": "New user PUK code",
    "adminPinCode": "Admin PIN code"
  }
}
